// Mock data for Livelong Wealth Real Estate Website

export const LOGO_URL = "/images/livelong-logo.png";

export const COMPANY = {
  name: "livelong realty",
  tagline: "Your Trusted Partner for Premium Real Estate",
  email: "realty@livelongwealth.com",
  phone: "+91 98765 43210",
  address: "Bangalore, Karnataka, India",
  mapUrl: "https://maps.app.goo.gl/C2f6Cm84MBbRmkHj7",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.5!2d77.59!3d12.93!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU1JzQ4LjAiTiA3N8KwMzUnMjQuMCJF!5e0!3m2!1sen!2sin!4v1",
  instagram: "https://www.instagram.com/livelong__realty/",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Properties", href: "#properties" },
  { label: "About Us", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const STATS = [
  { icon: "building", value: "1000+", label: "PROPERTIES SOLD" },
  { icon: "users", value: "1,200+", label: "HAPPY CLIENTS" },
  { icon: "award", value: "10+", label: "YEARS EXPERIENCE" },
  { icon: "globe", value: "25+", label: "GLOBAL PARTNERS" },
];

export const PARTNERS = [
  { name: "Lodha", logo: "LODHA" },
  { name: "Puravankara", logo: "PURAVANKARA" },
  { name: "Provident", logo: "PROVIDENT" },
  { name: "Sobha", logo: "SOBHA" },
  { name: "Prestige", logo: "PRESTIGE" },
  { name: "Godrej", logo: "GODREJ" },
  { name: "Brigade", logo: "BRIGADE" },
  { name: "Salarpuria", logo: "SALARPURIA" },
];

export const PROPERTY_CATEGORIES = [
  { id: "plots", label: "Plots" },
  { id: "apartments", label: "Apartments" },
  { id: "villas", label: "Villas" },
];

// ==========================================
// PROPERTIES - Card listings for each tab
// ==========================================
export const PROPERTIES = {
  plots: [
    {
      id: "sobha-chartered-birdsong",
      name: "Sobha Chartered Birdsong",
      location: "Yelahanka, North Bangalore",
      price: "Starting from \u20b984 Lakhs",
      size: "1200 - 3000 sq.ft Plots",
      image: "https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=600&h=400&fit=crop",
      badge: "NEW LAUNCH",
      type: "PLOT",
      builder: "Sobha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "purva-tivoli-hills",
      name: "Purva Tivoli Hills",
      location: "Devanahalli, North Bangalore",
      price: "Starting from \u20b91.60 Cr",
      size: "Residential & Commercial Plots",
      image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&h=400&fit=crop",
      badge: "PREMIUM",
      type: "PLOT",
      builder: "Puravankara",
      featured: true,
      hasDetail: true,
    },
  ],
  apartments: [
    // ===== SOBHA PROJECTS (ON TOP) =====
    {
      id: "sobha-townpark",
      name: "Sobha Town Park",
      location: "Hosur Road, South Bangalore",
      price: "Starting from \u20b91.60 Cr",
      size: "2, 3, 4 & 4.5 BHK",
      image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Sobha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "sobha-neopolis",
      name: "Sobha Neopolis",
      location: "Panathur Road, East Bangalore",
      price: "Starting from \u20b987 Lakhs",
      size: "1, 3, 3.5 & 4 BHK",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Sobha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "sobha-altair",
      name: "Sobha Altair",
      location: "Sarjapur Road, East Bangalore",
      price: "Starting from \u20b92.37 Cr",
      size: "3, 3.5 & 4 BHK",
      image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=400&fit=crop",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Sobha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "sobha-magnus",
      name: "Sobha Magnus",
      location: "Bannerghatta Road, South Bangalore",
      price: "Starting from \u20b92.00 Cr",
      size: "3 & 4 BHK + Row Houses",
      image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&h=400&fit=crop",
      badge: "PREMIUM",
      type: "APARTMENT",
      builder: "Sobha",
      featured: false,
      hasDetail: true,
    },
    {
      id: "sobha-infinia",
      name: "Sobha Infinia",
      location: "Koramangala, Central Bangalore",
      price: "Starting from \u20b92.50 Cr",
      size: "3 & 4 BHK",
      image: "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=600&h=400&fit=crop",
      badge: "LUXURY",
      type: "APARTMENT",
      builder: "Sobha",
      featured: false,
      hasDetail: true,
    },
    {
      id: "sobha-insignia",
      name: "Sobha Insignia",
      location: "Bhoganahalli, East Bangalore",
      price: "Starting from \u20b92.80 Cr",
      size: "3, 3.5 & 4 BHK",
      image: "/images/insignia/img_1_0.jpeg",
      badge: "SOLD OUT",
      type: "APARTMENT",
      builder: "Sobha",
      featured: false,
      hasDetail: true,
    },
    {
      id: "sobha-ayana",
      name: "Sobha Ayana",
      location: "Panathur, East Bangalore",
      price: "Starting from \u20b91.96 Cr",
      size: "3 BHK",
      image: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Sobha",
      featured: false,
      hasDetail: true,
    },
    {
      id: "sobha-hoskote",
      name: "Sobha Hoskote",
      location: "Hoskote Road, East Bangalore",
      price: "Starting from \u20b94.75 Cr",
      size: "4 BHK Duplex & Triplex",
      image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&h=400&fit=crop",
      badge: "PREMIUM",
      type: "APARTMENT",
      builder: "Sobha",
      featured: false,
      hasDetail: true,
    },
    // ===== BRIGADE PROJECTS =====
    {
      id: "brigade-eternia",
      name: "Brigade Eternia",
      location: "Yelahanka Main Road, North Bangalore",
      price: "Starting from \u20b970 Lakhs",
      size: "1, 2, 2.5, 3, 3.5 & 4 BHK",
      image: "/images/doc_wa/img_0_1.jpeg",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-ebony",
      name: "Ebony at Brigade Orchards",
      location: "Devanahalli, North Bangalore",
      price: "Starting from \u20b91.25 Cr",
      size: "3 & 4 BHK",
      image: "/images/ebony/img_4_0.jpeg",
      badge: "UNDER CONSTRUCTION",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-laurel-maple",
      name: "Brigade Laurel & Maple",
      location: "Devanahalli, North Bangalore",
      price: "Starting from \u20b91.50 Cr",
      size: "Senior & Multigenerational Living",
      image: "/images/lm/img_1_0.jpeg",
      badge: "UNIQUE CONCEPT",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-arcade-orchards",
      name: "Brigade Arcade at Orchards",
      location: "Devanahalli, North Bangalore",
      price: "Starting from \u20b960 Lakhs",
      size: "Retail & Office Spaces",
      image: "/images/brigade/img_0_1.jpeg",
      badge: "COMMERCIAL",
      type: "COMMERCIAL",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-valencia-brillio",
      name: "Brillio at Brigade Valencia",
      location: "Bommasandra, Electronic City, South Bangalore",
      price: "Starting from \u20b957.55 Lakhs",
      size: "1, 2, 3 & 4 BHK",
      image: "/images/valencia/img_0_15.jpeg",
      badge: "MEGA PROJECT",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-citrine",
      name: "Brigade Citrine",
      location: "Budigere Cross, Old Madras Road, East Bangalore",
      price: "Starting from \u20b968.9 Lakhs",
      size: "1, 2, 3 & 4 BHK",
      image: "/images/citrine/img_15_0.jpeg",
      badge: "NET ZERO",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-lakecrest",
      name: "Brigade Lakecrest",
      location: "Old Madras Road, KR Puram, East Bangalore",
      price: "Starting from \u20b956.59 Lakhs",
      size: "1 RK, 1, 2, 2.5 & 3 BHK",
      image: "/images/lakecrest/page_2.jpeg",
      badge: "LAKESIDE LIVING",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "brigade-belvedere",
      name: "Brigade Belvedere",
      location: "Budigere Cross, East Bangalore",
      price: "Starting from \u20b995 Lakhs",
      size: "1, 2, 3 & 3.5 BHK",
      image: "/images/belvedere/img_2_0.jpeg",
      badge: "43 FLOORS",
      type: "APARTMENT",
      builder: "Brigade",
      featured: false,
      hasDetail: true,
    },
    {
      id: "sobha-avalon",
      name: "Sobha Avalon",
      location: "GIFT City, Gandhinagar, Gujarat",
      price: "Starting from \u20b91.35 Cr",
      size: "1, 1.5, 2 & 3 BHK",
      image: "/images/avalon/img_0_0.jpeg",
      badge: "OUTSTATION",
      type: "APARTMENT",
      builder: "Sobha",
      featured: false,
      hasDetail: true,
    },
    // ===== LODHA PROJECTS =====
    {
      id: "lodha-azur",
      name: "Lodha Azur",
      location: "Bannerghatta Road, South Bangalore",
      price: "Starting from \u20b92.37 Cr",
      size: "3, 3.5 & 4 BHK",
      image: "/images/imported/imported-3.jpeg",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Lodha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "lodha-elanza",
      name: "Lodha Elanza",
      location: "Sarjapur Road, East Bangalore",
      price: "Starting from \u20b92.06 Cr",
      size: "3 & 3.5 BHK",
      image: "/images/imported/imported-4.jpeg",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Lodha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "lodha-haven",
      name: "Lodha Haven",
      location: "Hosa Road, Bangalore",
      price: "Starting from ₹1.80 Cr",
      size: "2, 3 & 4 BHK",
      image: "/images/lodha-haven/lodha-haven-1.jpeg",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Lodha",
      featured: true,
      hasDetail: true,
    },
    // ===== PURAVANKARA / PURVA PROJECTS =====
    {
      id: "purva-orient-grand",
      name: "Purva Orient Grand",
      location: "Lal Bagh Road, Central Bangalore",
      price: "Starting from \u20b95.55 Cr",
      size: "3 & 4 BHK",
      image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop",
      badge: "LUXURY",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: true,
      hasDetail: true,
    },
    {
      id: "purva-meraki",
      name: "Purva Meraki",
      location: "South Bangalore",
      price: "Starting from \u20b94.16 Cr",
      size: "3 & 4 BHK",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop",
      badge: "PREMIUM",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    {
      id: "purva-blubelle",
      name: "Purva BluBelle",
      location: "Magadi Road, Central Bangalore",
      price: "Starting from \u20b93.80 Cr",
      size: "3 BHK",
      image: "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=600&h=400&fit=crop",
      badge: "PREMIUM",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    {
      id: "purva-atmosphere",
      name: "Purva Atmosphere",
      location: "North Bangalore",
      price: "Starting from \u20b91.50 Cr",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1567684014761-b65e2e59b9eb?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    {
      id: "purva-northern-lights",
      name: "Purva Northern Lights",
      location: "North Bangalore",
      price: "Starting from \u20b91.40 Cr",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    {
      id: "purva-zenium",
      name: "Purva Zenium",
      location: "North Bangalore",
      price: "Starting from \u20b91.30 Cr",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    {
      id: "purva-park-hills",
      name: "Purva Park Hills",
      location: "Kanakapura Road, South Bangalore",
      price: "Starting from \u20b91.85 Cr",
      size: "3 BHK",
      image: "https://images.unsplash.com/photo-1680919838857-d54e011093d3?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    {
      id: "purva-silversky",
      name: "Purva Silversky",
      location: "Electronic City, South Bangalore",
      price: "Starting from \u20b91.20 Cr",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1632743441209-8a09b8a37e25?w=600&h=400&fit=crop",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Puravankara",
      featured: false,
      hasDetail: true,
    },
    // ===== PROVIDENT PROJECTS =====
    {
      id: "provident-botanico",
      name: "Provident Botanico",
      location: "Whitefield, East Bangalore",
      price: "Starting from \u20b986 Lakhs",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&h=400&fit=crop",
      badge: "FEATURED",
      type: "APARTMENT",
      builder: "Provident",
      featured: false,
      hasDetail: true,
    },
    {
      id: "provident-capella",
      name: "Provident Capella",
      location: "Whitefield, East Bangalore",
      price: "Starting from \u20b936.5 Lakhs",
      size: "Studio, 1, 2, 2.5 & 3 BHK",
      image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&h=400&fit=crop",
      badge: "READY TO MOVE",
      type: "APARTMENT",
      builder: "Provident",
      featured: false,
      hasDetail: true,
    },
    {
      id: "provident-deansgate",
      name: "Provident Deansgate",
      location: "North Bangalore",
      price: "Starting from \u20b980 Lakhs",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?w=600&h=400&fit=crop",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Provident",
      featured: false,
      hasDetail: true,
    },
    {
      id: "provident-ecopolitan",
      name: "Provident Ecopolitan",
      location: "North Bangalore",
      price: "Starting from \u20b975 Lakhs",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?w=600&h=400&fit=crop",
      badge: "NEW LAUNCH",
      type: "APARTMENT",
      builder: "Provident",
      featured: false,
      hasDetail: true,
    },
    {
      id: "provident-park-square",
      name: "Provident Park Square",
      location: "Kanakapura Road, South Bangalore",
      price: "Starting from \u20b949.59 Lakhs",
      size: "1, 1.5, 2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?w=600&h=400&fit=crop",
      badge: "VALUE PICK",
      type: "APARTMENT",
      builder: "Provident",
      featured: false,
      hasDetail: true,
    },
    {
      id: "provident-sunworth-city",
      name: "Provident Sunworth City",
      location: "Mysore Road, South Bangalore",
      price: "Starting from \u20b960 Lakhs",
      size: "2 & 3 BHK",
      image: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600&h=400&fit=crop",
      badge: "MEGA TOWNSHIP",
      type: "APARTMENT",
      builder: "Provident",
      featured: false,
      hasDetail: true,
    },
  ],
  villas: [
    {
      id: "sobha-lifestyle-legacy",
      name: "Sobha Lifestyle Legacy",
      location: "IVC Road, Devanahalli, North Bangalore",
      price: "Starting from \u20b95.00 Cr",
      size: "3 & 4 BHK Luxury Villas",
      image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=600&h=400&fit=crop",
      badge: "SUPER LUXURY",
      type: "VILLA",
      builder: "Sobha",
      featured: true,
      hasDetail: true,
    },
    {
      id: "purva-sparkling-springs",
      name: "Purva Sparkling Springs",
      location: "Bannerghatta Road, South Bangalore",
      price: "Starting from \u20b94.80 Cr",
      size: "3 & 4 BHK Villas",
      image: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=600&h=400&fit=crop",
      badge: "LUXURY VILLA",
      type: "VILLA",
      builder: "Puravankara",
      featured: true,
      hasDetail: true,
    },
  ],
};

// ==========================================
// PROJECT DETAILS - Full details for modal
// ==========================================
export const PROJECT_DETAILS = {
  // ===== LODHA AZUR =====
  "lodha-azur": {
    id: "lodha-azur",
    name: "Lodha Azur",
    builder: "Lodha Group",
    tagline: "Luxury Lake-View Living at Bannerghatta Road",
    location: "Bannerghatta Road, Begur/Hulimavu, South Bangalore",
    price: "Starting from \u20b92.37 Cr",
    priceRange: "\u20b92.37 Cr - \u20b94.05 Cr",
    pricePerSqft: "\u20b912,640 - \u20b913,500/sq.ft",
    rera: "PRM/KA/RERA/1251/310/PR/220324/006728",
    possession: "2027 - 2029",
    launchDate: "March 2024",
    status: "Under Construction",
    landArea: "10+ Acres",
    towers: "4-5 Towers",
    floors: "B+G+28-35 Floors",
    totalUnits: "550+ Units",
    openSpace: "80% Open Space",
    parking: "3-Level Basement",
    images: [
      { url: "/images/imported/imported-3.jpeg", caption: "Lodha Azur - Lake View Tower" },
      { url: "/images/imported/imported-8.jpeg", caption: "Aerial View - Hulimavu Lake" },
      { url: "/images/imported/imported-6.jpeg", caption: "Panoramic Lake & City View" },
      { url: "/images/imported/imported-5.jpeg", caption: "Grand Entrance & Lobby" },
      { url: "/images/imported/imported-2.jpeg", caption: "Luxury Balcony with Lake View" },
    ],
    configurations: [
      { type: "3 BHK", size: "1265 - 2000 sq.ft", price: "\u20b92.37 Cr onwards" },
      { type: "3.5 BHK", size: "1583 - 2439 sq.ft", price: "\u20b92.99 Cr onwards" },
      { type: "4 BHK", size: "1988 - 3060 sq.ft", price: "\u20b93.15 Cr onwards" },
    ],
    description: "Lodha Azur is an exquisite luxury residential project by the renowned Lodha Group, situated on the prestigious Bannerghatta Road in South Bangalore. Nestled alongside the serene Hulimavu Lake, this development offers breathtaking lake views and world-class amenities spread across 10+ acres of lush green landscape.",
    highlights: ["Adjoining Hulimavu Lake with stunning lake views", "10+ acres with 80% open space", "20,000+ sq.ft world-class clubhouse", "50+ premium amenities", "3-level basement parking", "4 min to Metro Station", "Near Royal Meenakshi Mall & Fortis Hospital", "RERA Registered"],
    amenities: ["Olympic-size Swimming Pool", "Kids Pool", "Fully Equipped Gymnasium", "Jogging & Cycling Track", "Badminton Court", "Tennis Court", "Basketball Court", "Cricket Pitch", "Wall Climbing", "20,000+ sq.ft Clubhouse", "Multipurpose Party Hall", "Mini Theatre", "Amphitheatre", "Yoga & Meditation Area", "Indoor Games Room", "Caf\u00e9", "Senior Citizen Zone", "Landscaped Gardens", "Kids Play Area", "Pet Park", "Forest Trail", "Skating Rink", "24x7 Security & CCTV", "100% DG Backup", "Rainwater Harvesting"],
    nearbyPlaces: [{ name: "Metro Station", distance: "4 min" }, { name: "NICE Ring Road", distance: "2.5 km" }, { name: "Royal Meenakshi Mall", distance: "8 min" }, { name: "Fortis Hospital", distance: "3.9 km" }, { name: "Podar International School", distance: "5.5 km" }],
  },

  // ===== LODHA ELANZA =====
  "lodha-elanza": {
    id: "lodha-elanza",
    name: "Lodha Elanza",
    builder: "Lodha Group",
    tagline: "Sarjapur Road's Most Anticipated Luxury Address",
    location: "Sarjapur Road, East Bangalore",
    price: "Starting from \u20b92.06 Cr",
    priceRange: "\u20b92.06 Cr - \u20b93.50 Cr",
    pricePerSqft: "\u20b913,500 - \u20b915,200/sq.ft",
    rera: "",
    possession: "2028 - 2030",
    launchDate: "2025",
    status: "New Launch",
    landArea: "19 Acres",
    towers: "Multiple Towers",
    floors: "G+34 Floors",
    totalUnits: "Limited Edition",
    openSpace: "80% Open Space",
    parking: "Basement Parking",
    mapUrl: "https://maps.app.goo.gl/HS2jn4Cu75tEZY4x9",
    images: [
      { url: "/images/imported/imported-4.jpeg", caption: "Luxury Living Room with Lake View" },
      { url: "/images/imported/imported-1.jpeg", caption: "Low Density Living - 100% Privacy" },
      { url: "/images/imported/imported-9.jpeg", caption: "Serene Twin Lake Views" },
      { url: "/images/elanza/cover.jpeg", caption: "Lodha Elanza - Project Overview" },
      { url: "/images/elanza/aerial1.jpeg", caption: "Aerial View of the Township" },
      { url: "/images/elanza/amenities1.jpeg", caption: "World-Class Amenities" },
      { url: "/images/elanza/garden1.jpeg", caption: "Lush Landscaped Gardens" },
      { url: "/images/elanza/pool1.jpeg", caption: "Premium Swimming Pool & Deck" },
      { url: "/images/elanza/exterior1.jpeg", caption: "Tower Exterior View" },
      { url: "/images/elanza/clubhouse1.jpeg", caption: "Clubhouse & Recreation" },
      { url: "/images/elanza/landscape1.jpeg", caption: "Nature-Inspired Landscape Design" },
      { url: "/images/elanza/masterplan.jpeg", caption: "Master Plan Layout" },
    ],
    videos: [
      { url: "/images/imported/imported-7.mp4", caption: "Lodha Elanza - Project Walkthrough" },
      { url: "/images/imported/imported-10.mp4", caption: "Lodha Elanza - Lifestyle Preview" },
      { url: "/images/imported/imported-11.mp4", caption: "Lodha Elanza - Community & Surroundings" },
    ],
    configurations: [
      { type: "3 BHK Smart", size: "1,500 sq.ft SBA (979 sq.ft carpet)", price: "\u20b92.06 Cr onwards", subtitle: "Elite Trine Homes" },
      { type: "3 BHK Luxe", size: "1,900 sq.ft SBA (1,236 sq.ft carpet)", price: "\u20b92.50 - \u20b92.65 Cr", subtitle: "Crown 3 Residences" },
      { type: "3.5 BHK", size: "2,300 sq.ft SBA (1,500 sq.ft carpet)", price: "\u20b93.15 - \u20b93.50 Cr", subtitle: "Trio Residences" },
    ],
    description: "Lodha Elanza is Sarjapur Road's most anticipated luxury address by Lodha Group. Spread across 19 acres with 80% open areas \u2014 a rare luxury in Bengaluru's urban landscape. Designed as a low-density, nature-first enclave with twin lakes on East & West sides, it offers 100% privacy with no tower looking into each other.",
    highlights: ["19 acres with 80% open space", "Low-density living with 100% privacy", "Twin lakes \u2014 one on each side (East & West)", "No tower looking into each other", "G+34 floors with panoramic views", "Near Whitefield & Electronic City IT corridors", "Excellent ORR connectivity", "Premium schools, hospitals & lifestyle nearby"],
    amenities: ["Swimming Pool", "Fully Equipped Gymnasium", "Landscaped Gardens", "Jogging & Cycling Track", "Children's Play Area", "Clubhouse", "Multipurpose Hall", "Indoor Games Room", "Yoga & Meditation Zone", "Senior Citizen Area", "Amphitheatre", "Sports Courts", "Pet-Friendly Zones", "24x7 Security & CCTV", "Power Backup", "Rainwater Harvesting", "EV Charging Stations", "Concierge Services"],
    nearbyPlaces: [{ name: "Whitefield IT Hub", distance: "15 min" }, { name: "Electronic City", distance: "20 min" }, { name: "Outer Ring Road", distance: "5 min" }, { name: "Premium Schools", distance: "Nearby" }, { name: "Hospitals & Healthcare", distance: "Nearby" }],
  },

  // ===== LODHA HAVEN =====
  "lodha-haven": {
    id: "lodha-haven",
    name: "Lodha Haven",
    builder: "Lodha Group",
    tagline: "Live in Paradise - Premium Living at Hosa Road",
    location: "Hosa Road, Bangalore",
    price: "Starting from ₹1.80 Cr",
    priceRange: "₹1.80 Cr - ₹3.20 Cr",
    pricePerSqft: "₹11,500 - ₹13,000/sq.ft",
    rera: "PRM/KA/RERA/1251/446/PR/171019/005515",
    possession: "2027 - 2028",
    launchDate: "2024",
    status: "Under Construction",
    landArea: "12+ Acres",
    towers: "Multiple Towers",
    floors: "G+29 Floors",
    totalUnits: "600+ Premium Residences",
    openSpace: "75% Open Space",
    parking: "Multi-Level Basement Parking",
    mapUrl: "https://maps.app.goo.gl/C2f6Cm84MBbRmkHj7",
    images: [
      { url: "/images/lodha-haven/lodha-haven-1.jpeg", caption: "Lodha Haven - Grand Entrance" },
      { url: "/images/lodha-haven/lodha-haven-2.jpeg", caption: "Luxury Tower Facade" },
      { url: "/images/lodha-haven/lodha-haven-3.jpeg", caption: "Premium Amenities Overview" },
      { url: "/images/lodha-haven/lodha-haven-4.jpeg", caption: "Landscaped Gardens & Recreation" },
      { url: "/images/lodha-haven/lodha-haven-5.jpeg", caption: "Modern Living Spaces" },
      { url: "/images/lodha-haven/lodha-haven-6.jpeg", caption: "Clubhouse & Community Spaces" },
      { url: "/images/lodha-haven/lodha-haven-7.jpeg", caption: "Swimming Pool & Deck" },
      { url: "/images/lodha-haven/lodha-haven-8.jpeg", caption: "State-of-the-Art Gymnasium" },
      { url: "/images/lodha-haven/lodha-haven-9.jpeg", caption: "Children's Play Area" },
      { url: "/images/lodha-haven/lodha-haven-10.jpeg", caption: "Sports Facilities" },
      { url: "/images/lodha-haven/lodha-haven-11.jpeg", caption: "Serene Walkways" },
      { url: "/images/lodha-haven/lodha-haven-12.jpeg", caption: "Premium Interiors" },
      { url: "/images/lodha-haven/lodha-haven-13.jpeg", caption: "Elegant Living Room Design" },
      { url: "/images/lodha-haven/lodha-haven-14.jpeg", caption: "Master Bedroom Layout" },
      { url: "/images/lodha-haven/lodha-haven-15.jpeg", caption: "Panoramic City Views" },
      { url: "/images/lodha-haven/lodha-haven-16.jpeg", caption: "Tower Exterior Night View" },
      { url: "/images/lodha-haven/lodha-haven-17.jpeg", caption: "Lifestyle Amenities" },
      { url: "/images/lodha-haven/lodha-haven-18.jpeg", caption: "Community Hub" },
      { url: "/images/lodha-haven/lodha-haven-19.jpeg", caption: "Project Master Plan" },
      { url: "/images/lodha-haven/lodha-haven-20.jpeg", caption: "Location Advantages" },
    ],
    configurations: [
      { type: "2 BHK", size: "1,150 - 1,350 sq.ft", price: "₹1.80 Cr onwards" },
      { type: "3 BHK", size: "1,550 - 1,850 sq.ft", price: "₹2.40 Cr onwards" },
      { type: "4 BHK", size: "2,200 - 2,600 sq.ft", price: "₹3.20 Cr onwards" },
    ],
    description: "Lodha Haven is a premium residential development by India's leading real estate developer, Lodha Group. Strategically located at Hosa Road, between Hosur Road and Sarjapur Road, within Bangalore's pre-eminent IT hub. The project offers seamless connectivity to Electronic City, Outer Ring Road, and is a stone's throw away from the metro station. With thoughtfully designed residences and world-class amenities, Lodha Haven creates a paradise for modern living.",
    highlights: [
      "Prime location at Hosa Road near Metro Station",
      "12+ acres with 75% open green spaces",
      "Seamless connectivity to Electronic City & ORR",
      "600+ premium residences across G+29 floors",
      "From India's largest & most trusted developer",
      "Close to Manipal & Narayana Multi-specialty Hospitals",
      "Near leading schools & educational institutions",
      "High-street shopping & fine dining nearby",
      "RERA Registered Project",
      "Robust infrastructure & social hotspots"
    ],
    amenities: [
      "Grand Clubhouse",
      "Olympic-size Swimming Pool",
      "Kids Swimming Pool",
      "Fully Equipped Gymnasium",
      "Indoor Sports Complex",
      "Badminton Court",
      "Tennis Court",
      "Basketball Court",
      "Cricket Practice Nets",
      "Jogging & Cycling Track",
      "Yoga & Meditation Pavilion",
      "Multipurpose Party Hall",
      "Amphitheatre",
      "Indoor Games Room",
      "Library & Reading Room",
      "Children's Play Area",
      "Senior Citizen Zone",
      "Landscaped Gardens",
      "Reflexology Path",
      "Pet Park",
      "Outdoor Seating Areas",
      "Café & Food Court",
      "Convenience Store",
      "24x7 Security with CCTV",
      "Multi-Level Parking",
      "100% Power Backup",
      "Rainwater Harvesting",
      "Sewage Treatment Plant",
      "EV Charging Stations"
    ],
    nearbyPlaces: [
      { name: "Metro Station", distance: "500 meters" },
      { name: "Electronic City", distance: "6 km" },
      { name: "Outer Ring Road", distance: "3 km" },
      { name: "Manipal Hospital", distance: "4 km" },
      { name: "Narayana Multi-specialty Hospital", distance: "5 km" },
      { name: "International Schools", distance: "2-4 km" },
      { name: "Shopping Malls", distance: "3-5 km" },
      { name: "Tech Parks", distance: "5-8 km" }
    ],
  },


  // ===== PURVA ORIENT GRAND =====
  "purva-orient-grand": {
    id: "purva-orient-grand", name: "Purva Orient Grand", builder: "Puravankara", tagline: "Ultra-Luxury Living at Lal Bagh Road",
    location: "Lal Bagh Road, Central Bangalore", price: "Starting from \u20b95.55 Cr", priceRange: "\u20b95.55 Cr - \u20b96.00 Cr", pricePerSqft: "\u20b927,000+/sq.ft",
    rera: "PR/210907/004299", possession: "June 2027", launchDate: "2021", status: "Under Construction",
    landArea: "3+ Acres", towers: "2 Towers", floors: "G+30 Floors", totalUnits: "180+ Units", openSpace: "70% Open Space", parking: "Multi-Level Basement",
    configurations: [{ type: "3 BHK", size: "1992 sq.ft", price: "\u20b95.55 Cr onwards" }, { type: "4 BHK", size: "2262 sq.ft", price: "\u20b96.00 Cr onwards" }],
    description: "Purva Orient Grand is an ultra-luxury development by Puravankara located on the iconic Lal Bagh Road in the heart of Bangalore. With magnificent views of Lal Bagh Botanical Garden, this project offers 3 & 4 BHK residences with world-class specifications and premium finishes.",
    highlights: ["Prime Lal Bagh Road location", "Iconic city center address", "Panoramic views of Lal Bagh Garden", "Ultra-premium specifications", "Smart home features", "Walking distance to metro", "Top schools & hospitals nearby", "RERA Registered"],
    amenities: ["Infinity Swimming Pool", "Gymnasium", "Clubhouse", "Landscaped Gardens", "Indoor Games", "Party Hall", "Yoga Deck", "Children's Play Area", "24x7 Security", "Power Backup"],
    nearbyPlaces: [{ name: "Lal Bagh Garden", distance: "Walking" }, { name: "Metro Station", distance: "5 min" }, { name: "MG Road", distance: "10 min" }, { name: "Hospitals", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop", caption: "Purva Orient Grand Exterior" }],
  },

  // ===== PURVA MERAKI =====
  "purva-meraki": {
    id: "purva-meraki", name: "Purva Meraki", builder: "Puravankara", tagline: "Where Art Meets Architecture",
    location: "South Bangalore", price: "Starting from \u20b94.16 Cr", priceRange: "\u20b94.16 Cr - \u20b96.00 Cr", pricePerSqft: "\u20b916,500+/sq.ft",
    rera: "PR/071022/005307", possession: "October 2027", launchDate: "2022", status: "Under Construction",
    landArea: "5+ Acres", towers: "3 Towers", floors: "G+25 Floors", totalUnits: "250+ Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "2519 sq.ft", price: "\u20b94.16 Cr onwards" }, { type: "4 BHK", size: "3745 sq.ft", price: "\u20b96.00 Cr onwards" }],
    description: "Purva Meraki is a luxury residential project where art meets architecture. Offering spacious 3 & 4 BHK apartments with premium interiors, this South Bangalore address is designed for those who appreciate the finer things in life.",
    highlights: ["Premium South Bangalore location", "Artistically designed residences", "Spacious 3 & 4 BHK configurations", "Premium lobby & common areas", "Sustainable building design", "Close to IT hubs", "Top educational institutions nearby", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Tennis Court", "Basketball Court", "Party Hall", "Library", "Spa", "Children's Play Area", "24x7 Security"],
    nearbyPlaces: [{ name: "IT Corridor", distance: "10 min" }, { name: "Schools", distance: "Nearby" }, { name: "Hospitals", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop", caption: "Purva Meraki Tower View" }],
  },

  // ===== PURVA BLUBELLE =====
  "purva-blubelle": {
    id: "purva-blubelle", name: "Purva BluBelle", builder: "Puravankara", tagline: "A New Shade of Luxury Living",
    location: "Magadi Road, Central Bangalore", price: "Starting from \u20b93.80 Cr", priceRange: "\u20b93.80 Cr onwards", pricePerSqft: "\u20b925,000+/sq.ft",
    rera: "PR/290323/005829", possession: "June 2028", launchDate: "2023", status: "Under Construction",
    landArea: "3 Acres", towers: "2 Towers", floors: "G+28 Floors", totalUnits: "200+ Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "1434 sq.ft", price: "\u20b93.80 Cr onwards" }, { type: "3 BHK Large", size: "1631 sq.ft", price: "\u20b94.30 Cr onwards" }],
    description: "Purva BluBelle on Magadi Road offers a new shade of luxury living in Central Bangalore. With thoughtfully designed 3 BHK residences and premium amenities, this project is perfect for families seeking a prime city-center location.",
    highlights: ["Central Bangalore location", "Walking distance to metro", "Premium 3 BHK configurations", "Modern design aesthetics", "Smart home features", "Excellent connectivity", "Near shopping & entertainment", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Children's Play Area", "Multipurpose Hall", "Indoor Games", "24x7 Security"],
    nearbyPlaces: [{ name: "Metro Station", distance: "Walking" }, { name: "Rajajinagar", distance: "5 min" }, { name: "Hospitals", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=600&h=400&fit=crop", caption: "Purva BluBelle Exterior" }],
  },

  // ===== PURVA ATMOSPHERE =====
  "purva-atmosphere": {
    id: "purva-atmosphere", name: "Purva Atmosphere", builder: "Puravankara", tagline: "Breathe in the Atmosphere of Premium Living",
    location: "North Bangalore", price: "Starting from \u20b91.50 Cr", priceRange: "\u20b91.50 Cr - \u20b92.20 Cr", pricePerSqft: "\u20b912,000/sq.ft",
    rera: "", possession: "2027", launchDate: "2024", status: "Under Construction",
    landArea: "8 Acres", towers: "4 Towers", floors: "G+22 Floors", totalUnits: "400+ Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "2 BHK", size: "1100 sq.ft", price: "\u20b91.50 Cr onwards" }, { type: "3 BHK", size: "1500 sq.ft", price: "\u20b92.00 Cr onwards" }],
    description: "Purva Atmosphere in North Bangalore offers a refreshing residential experience with spacious 2 & 3 BHK apartments. Surrounded by greenery and equipped with modern amenities, this project is ideal for families and professionals near the airport corridor.",
    highlights: ["North Bangalore growth corridor", "Near international airport", "Spacious 2 & 3 BHK", "Lush green surroundings", "Excellent appreciation potential", "Premium amenities", "Near IT parks", "Well-connected to ORR"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Tennis Court", "Children's Play Area", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "KIA Airport", distance: "20 min" }, { name: "Manyata Tech Park", distance: "15 min" }, { name: "ORR", distance: "10 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1567684014761-b65e2e59b9eb?w=600&h=400&fit=crop", caption: "Purva Atmosphere" }],
  },

  // ===== PURVA NORTHERN LIGHTS =====
  "purva-northern-lights": {
    id: "purva-northern-lights", name: "Purva Northern Lights", builder: "Puravankara", tagline: "Illuminate Your Life in North Bangalore",
    location: "North Bangalore", price: "Starting from \u20b91.40 Cr", priceRange: "\u20b91.40 Cr - \u20b92.00 Cr", pricePerSqft: "\u20b911,500/sq.ft",
    rera: "", possession: "2027", launchDate: "2024", status: "Under Construction",
    landArea: "7 Acres", towers: "3 Towers", floors: "G+20 Floors", totalUnits: "350+ Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "2 BHK", size: "1050 sq.ft", price: "\u20b91.40 Cr onwards" }, { type: "3 BHK", size: "1450 sq.ft", price: "\u20b91.80 Cr onwards" }],
    description: "Purva Northern Lights brings premium living to North Bangalore's fastest-growing corridor. With smart layouts, modern design, and excellent connectivity to airport and IT hubs, this project offers outstanding value.",
    highlights: ["Strategic North Bangalore location", "Near Devanahalli & Airport", "Smart apartment layouts", "Modern amenities", "Investment hotspot", "Green building certified", "Excellent connectivity", "Close to schools & hospitals"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Badminton Court", "Children's Play Area", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "KIA Airport", distance: "15 min" }, { name: "Hebbal", distance: "12 min" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=600&h=400&fit=crop", caption: "Purva Northern Lights" }],
  },

  // ===== PURVA ZENIUM =====
  "purva-zenium": {
    id: "purva-zenium", name: "Purva Zenium", builder: "Puravankara", tagline: "Zenith of Premium Living",
    location: "North Bangalore", price: "Starting from \u20b91.30 Cr", priceRange: "\u20b91.30 Cr - \u20b91.80 Cr", pricePerSqft: "\u20b911,000/sq.ft",
    rera: "", possession: "2027", launchDate: "2024", status: "Under Construction",
    landArea: "6 Acres", towers: "3 Towers", floors: "G+20 Floors", totalUnits: "300+ Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "2 BHK", size: "1000 sq.ft", price: "\u20b91.30 Cr onwards" }, { type: "3 BHK", size: "1400 sq.ft", price: "\u20b91.60 Cr onwards" }],
    description: "Purva Zenium represents the zenith of premium living in North Bangalore. Thoughtfully designed apartments with modern amenities and excellent connectivity make it an ideal choice for professionals and families.",
    highlights: ["Prime North Bangalore location", "Well-designed 2 & 3 BHK", "Modern clubhouse", "Green surroundings", "Metro connectivity planned", "Close to IT hubs", "Investment-grade location", "Quality Puravankara construction"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Basketball Court", "Children's Play Area", "Indoor Games", "24x7 Security"],
    nearbyPlaces: [{ name: "Hebbal Junction", distance: "10 min" }, { name: "Manyata Tech Park", distance: "12 min" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=600&h=400&fit=crop", caption: "Purva Zenium" }],
  },

  // ===== PURVA PARK HILLS =====
  "purva-park-hills": {
    id: "purva-park-hills", name: "Purva Park Hills", builder: "Puravankara", tagline: "Elevated Living at Kanakapura Road",
    location: "Kanakapura Road, South Bangalore", price: "Starting from \u20b91.85 Cr", priceRange: "\u20b91.85 Cr - \u20b92.20 Cr", pricePerSqft: "\u20b910,500/sq.ft",
    rera: "PR/220601/004946", possession: "December 2027", launchDate: "2022", status: "Under Construction",
    landArea: "15 Acres", towers: "5 Towers", floors: "G+18 Floors", totalUnits: "600+ Units", openSpace: "80% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "1748 sq.ft", price: "\u20b91.85 Cr onwards" }, { type: "3 BHK Large", size: "1938 sq.ft", price: "\u20b92.05 Cr onwards" }],
    description: "Purva Park Hills at Kanakapura Road offers elevated living amidst nature. Spread across 15 acres with 80% open space, this project features spacious 3 BHK apartments with panoramic views and resort-style amenities.",
    highlights: ["15 acres of lush development", "80% open space", "Kanakapura Road premium corridor", "Near NICE Road junction", "Resort-style amenities", "Panoramic hill views", "Close to Art of Living", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Tennis Court", "Cricket Net", "Children's Play Area", "Amphitheatre", "Party Hall", "Yoga Pavilion", "Senior Citizen Area", "24x7 Security"],
    nearbyPlaces: [{ name: "NICE Ring Road", distance: "5 min" }, { name: "Art of Living", distance: "10 min" }, { name: "Fun World", distance: "15 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1680919838857-d54e011093d3?w=600&h=400&fit=crop", caption: "Purva Park Hills" }],
  },

  // ===== PURVA SILVERSKY =====
  "purva-silversky": {
    id: "purva-silversky", name: "Purva Silversky", builder: "Puravankara", tagline: "Sky-High Living at Electronic City",
    location: "Electronic City, South Bangalore", price: "Starting from \u20b91.20 Cr", priceRange: "\u20b91.20 Cr - \u20b91.80 Cr", pricePerSqft: "\u20b910,000/sq.ft",
    rera: "", possession: "2028", launchDate: "2025", status: "New Launch",
    landArea: "8 Acres", towers: "4 Towers", floors: "G+25 Floors", totalUnits: "500+ Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "2 BHK", size: "1100 sq.ft", price: "\u20b91.20 Cr onwards" }, { type: "3 BHK", size: "1500 sq.ft", price: "\u20b91.60 Cr onwards" }],
    description: "Purva Silversky at Electronic City offers premium living in Bangalore's premier IT hub. With contemporary design, smart home features, and excellent connectivity, it's the perfect address for tech professionals.",
    highlights: ["Heart of Electronic City", "Walking distance to IT parks", "Smart home features", "Contemporary architecture", "Excellent metro connectivity", "Investment hotspot", "Premium clubhouse", "Green building design"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Badminton Court", "Children's Play Area", "Co-working Space", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "Infosys Campus", distance: "5 min" }, { name: "Wipro Campus", distance: "5 min" }, { name: "Metro Station", distance: "10 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1632743441209-8a09b8a37e25?w=600&h=400&fit=crop", caption: "Purva Silversky" }],
  },

  // ===== PROVIDENT BOTANICO =====
  "provident-botanico": {
    id: "provident-botanico", name: "Provident Botanico", builder: "Provident Housing", tagline: "Nature-Inspired Living at Whitefield",
    location: "Soukya Road, Whitefield, East Bangalore", price: "Starting from \u20b986 Lakhs", priceRange: "\u20b986 Lakhs - \u20b91.67 Cr", pricePerSqft: "\u20b98,700/sq.ft",
    rera: "PRM/KA/RERA/1250/304/PR/210324/006726", possession: "September 2028", launchDate: "2024", status: "Under Construction",
    landArea: "17 Acres", towers: "9 Towers", floors: "G+20 Floors", totalUnits: "1275 Units", openSpace: "80% Open Space", parking: "Basement Parking",
    configurations: [{ type: "2 BHK", size: "986 sq.ft", price: "\u20b986 Lakhs onwards" }, { type: "3 BHK", size: "1494 sq.ft", price: "\u20b91.25 Cr onwards" }],
    description: "Provident Botanico at Whitefield is a nature-inspired residential community spread across 17 acres. With 80% open space, 9 towers, and 1275 units, this project by Provident Housing offers excellent value in Bangalore's IT corridor.",
    highlights: ["17 acres of green development", "80% open space", "Near Whitefield IT Hub", "10 min to ITPL", "9 towers, 1275 units", "Affordable luxury", "Excellent appreciation", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Children's Play Area", "Sports Courts", "Indoor Games", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "ITPL Whitefield", distance: "10 min" }, { name: "Hope Farm Junction", distance: "5 min" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&h=400&fit=crop", caption: "Provident Botanico" }],
  },

  // ===== PROVIDENT CAPELLA =====
  "provident-capella": {
    id: "provident-capella", name: "Provident Capella", builder: "Provident Housing", tagline: "Smart Living Starts Here",
    location: "Soukya Road, Whitefield, East Bangalore", price: "Starting from \u20b936.5 Lakhs", priceRange: "\u20b936.5 Lakhs - \u20b91.25 Cr", pricePerSqft: "\u20b98,500/sq.ft",
    rera: "PRM/KA/RERA/1250/304/PR/190719/002702", possession: "June 2025", launchDate: "2019", status: "Ready to Move",
    landArea: "6 Acres", towers: "7 Towers", floors: "G+18 Floors", totalUnits: "763 Units", openSpace: "70% Open Space", parking: "Covered Parking",
    configurations: [{ type: "Studio Pod", size: "428 sq.ft", price: "\u20b936.5 Lakhs onwards" }, { type: "1 BHK", size: "540 sq.ft", price: "\u20b948.3 Lakhs onwards" }, { type: "2 BHK", size: "820 sq.ft", price: "\u20b974.8 Lakhs onwards" }, { type: "3 BHK", size: "1106 sq.ft", price: "\u20b91.25 Cr onwards" }],
    description: "Provident Capella at Whitefield is a smart-living community with studio pods to 3 BHK apartments. Ready-to-move-in with 763 units across 7 towers, this project offers outstanding value for young professionals and families.",
    highlights: ["Ready to Move In", "Starting from just \u20b936.5 Lakhs", "Studio to 3 BHK options", "Near Whitefield IT Hub", "Smart home features", "Modern design", "Excellent rental demand", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Co-working Space", "Jogging Track", "Children's Play Area", "Indoor Games", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "ITPL Whitefield", distance: "8 min" }, { name: "Hope Farm Junction", distance: "5 min" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&h=400&fit=crop", caption: "Provident Capella" }],
  },

  // ===== PROVIDENT DEANSGATE =====
  "provident-deansgate": {
    id: "provident-deansgate", name: "Provident Deansgate", builder: "Provident Housing", tagline: "Gateway to North Bangalore's Future",
    location: "North Bangalore", price: "Starting from \u20b980 Lakhs", priceRange: "\u20b980 Lakhs - \u20b91.40 Cr", pricePerSqft: "\u20b98,000/sq.ft",
    rera: "", possession: "2028", launchDate: "2025", status: "New Launch",
    landArea: "12 Acres", towers: "6 Towers", floors: "G+18 Floors", totalUnits: "800+ Units", openSpace: "75% Open Space", parking: "Covered Parking",
    configurations: [{ type: "2 BHK", size: "950 sq.ft", price: "\u20b980 Lakhs onwards" }, { type: "3 BHK", size: "1350 sq.ft", price: "\u20b91.20 Cr onwards" }],
    description: "Provident Deansgate is the gateway to North Bangalore's rapidly developing corridor. With affordable 2 & 3 BHK apartments near the airport, this project offers excellent investment potential and modern living.",
    highlights: ["North Bangalore growth corridor", "Near international airport", "Affordable pricing", "Modern amenities", "High appreciation potential", "Large township format", "Green building design", "Upcoming metro connectivity"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Sports Courts", "Children's Play Area", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "KIA Airport", distance: "20 min" }, { name: "IVC Road", distance: "Nearby" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?w=600&h=400&fit=crop", caption: "Provident Deansgate" }],
  },

  // ===== PROVIDENT ECOPOLITAN =====
  "provident-ecopolitan": {
    id: "provident-ecopolitan", name: "Provident Ecopolitan", builder: "Provident Housing", tagline: "Eco-Friendly Living for the Modern Family",
    location: "North Bangalore", price: "Starting from \u20b975 Lakhs", priceRange: "\u20b975 Lakhs - \u20b91.30 Cr", pricePerSqft: "\u20b97,800/sq.ft",
    rera: "", possession: "2028", launchDate: "2025", status: "New Launch",
    landArea: "15 Acres", towers: "8 Towers", floors: "G+16 Floors", totalUnits: "1000+ Units", openSpace: "80% Open Space", parking: "Covered Parking",
    configurations: [{ type: "2 BHK", size: "900 sq.ft", price: "\u20b975 Lakhs onwards" }, { type: "3 BHK", size: "1300 sq.ft", price: "\u20b91.10 Cr onwards" }],
    description: "Provident Ecopolitan brings eco-friendly living to North Bangalore. This green-certified township with 80% open space offers affordable 2 & 3 BHK apartments amidst nature while being well-connected to the city.",
    highlights: ["Eco-friendly green township", "15 acres with 80% open space", "North Bangalore location", "Affordable starting price", "Green building certification", "Large community format", "Near developing infrastructure", "Future metro connectivity"],
    amenities: ["Swimming Pool", "Gymnasium", "Eco Clubhouse", "Jogging Track", "Cycling Track", "Organic Garden", "Children's Play Area", "Solar Panels", "Rainwater Harvesting", "24x7 Security"],
    nearbyPlaces: [{ name: "Airport Road", distance: "15 min" }, { name: "Yelahanka", distance: "10 min" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?w=600&h=400&fit=crop", caption: "Provident Ecopolitan" }],
  },

  // ===== PROVIDENT PARK SQUARE =====
  "provident-park-square": {
    id: "provident-park-square", name: "Provident Park Square", builder: "Provident Housing", tagline: "Affordable Urban Living at Kanakapura Road",
    location: "Kanakapura Road, South Bangalore", price: "Starting from \u20b949.59 Lakhs", priceRange: "\u20b949.59 Lakhs - \u20b91.10 Cr", pricePerSqft: "\u20b97,500/sq.ft",
    rera: "", possession: "Ready to Move", launchDate: "2020", status: "Ready to Move",
    landArea: "20 Acres", towers: "12 Towers", floors: "G+14 Floors", totalUnits: "2082 Units", openSpace: "75% Open Space", parking: "Covered Parking",
    configurations: [{ type: "1 BHK", size: "517 sq.ft", price: "\u20b949.59 Lakhs onwards" }, { type: "1.5 BHK", size: "680 sq.ft", price: "\u20b965 Lakhs onwards" }, { type: "2 BHK", size: "920 sq.ft", price: "\u20b985 Lakhs onwards" }, { type: "3 BHK", size: "1314 sq.ft", price: "\u20b91.10 Cr onwards" }],
    description: "Provident Park Square is a 20-acre mega township at Kanakapura Road offering 1 to 3 BHK apartments. With 2082 units and ready-to-move options, this is one of South Bangalore's most popular affordable housing projects.",
    highlights: ["20-acre mega township", "2082 units across 12 towers", "Ready to move in", "Starting from \u20b949.59 Lakhs", "Near NICE Road junction", "1 to 3 BHK options", "Established community", "Near Art of Living Ashram"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Children's Play Area", "Sports Courts", "Party Hall", "Indoor Games", "24x7 Security"],
    nearbyPlaces: [{ name: "NICE Ring Road", distance: "5 min" }, { name: "Art of Living", distance: "10 min" }, { name: "Fun World", distance: "12 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?w=600&h=400&fit=crop", caption: "Provident Park Square" }],
  },

  // ===== PROVIDENT SUNWORTH CITY =====
  "provident-sunworth-city": {
    id: "provident-sunworth-city", name: "Provident Sunworth City", builder: "Provident Housing", tagline: "60-Acre Mega Township on Mysore Road",
    location: "Mysore Road / NICE Junction, South Bangalore", price: "Starting from \u20b960 Lakhs", priceRange: "\u20b960 Lakhs - \u20b91.20 Cr", pricePerSqft: "\u20b97,500/sq.ft",
    rera: "", possession: "2027", launchDate: "2023", status: "Under Construction",
    landArea: "60 Acres", towers: "20+ Towers", floors: "G+16 Floors", totalUnits: "4000+ Units", openSpace: "80% Open Space", parking: "Covered Parking",
    configurations: [{ type: "2 BHK", size: "850 sq.ft", price: "\u20b960 Lakhs onwards" }, { type: "3 BHK", size: "1250 sq.ft", price: "\u20b91.00 Cr onwards" }],
    description: "Provident Sunworth City is a massive 60-acre mega township on Mysore Road. With 4000+ units, this project offers a self-sustained community with all modern amenities, schools, retail, and recreation within the township.",
    highlights: ["60-acre mega township", "4000+ residential units", "Self-sustained community", "Near NICE Road junction", "Schools & retail within township", "Mysore Road connectivity", "Affordable starting price", "Future metro connectivity"],
    amenities: ["Olympic Swimming Pool", "Gymnasium", "Mega Clubhouse", "Jogging Track", "Cricket Ground", "Tennis Court", "Basketball Court", "Children's Play Area", "Amphitheatre", "Retail Area", "24x7 Security"],
    nearbyPlaces: [{ name: "NICE Ring Road", distance: "Adjacent" }, { name: "Mysore Road Metro", distance: "10 min" }, { name: "Global Village", distance: "5 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600&h=400&fit=crop", caption: "Provident Sunworth City" }],
  },

  // ===== PURVA SPARKLING SPRINGS (VILLA) =====
  "purva-sparkling-springs": {
    id: "purva-sparkling-springs", name: "Purva Sparkling Springs", builder: "Puravankara", tagline: "Luxury Villas on Bannerghatta Road",
    location: "Bannerghatta Road, South Bangalore", price: "Starting from \u20b94.80 Cr", priceRange: "\u20b94.80 Cr - \u20b97.00 Cr", pricePerSqft: "\u20b914,400/sq.ft",
    rera: "PRM/KA/RERA/1251/310/PR/210907/004300", possession: "February 2025", launchDate: "2021", status: "Ready to Move",
    landArea: "20 Acres", towers: "N/A (Villa)", floors: "G+2", totalUnits: "150 Villas", openSpace: "85% Open Space", parking: "Private Parking",
    configurations: [{ type: "3 BHK Villa", size: "3335 sq.ft", price: "\u20b94.80 Cr onwards" }, { type: "4 BHK Villa", size: "4477 sq.ft", price: "\u20b96.50 Cr onwards" }],
    description: "Purva Sparkling Springs offers luxury 3 & 4 BHK villas on Bannerghatta Road. Spread across 20 acres with 85% open space, these premium villas feature private gardens, wellness amenities, and a resort-like lifestyle minutes from Electronic City.",
    highlights: ["Luxury 3 & 4 BHK villas", "20 acres with 85% open space", "Ready to move in", "Private gardens for each villa", "Near Electronic City", "Resort-style amenities", "Infinity pool & wellness center", "RERA Registered"],
    amenities: ["Infinity Swimming Pool", "Wellness Center & Spa", "Gymnasium", "Grand Clubhouse", "Tennis Court", "Basketball Court", "Cricket Pitch", "Jogging Track", "Children's Play Area", "Amphitheatre", "Pet Park", "Indoor Games", "Meditation Garden", "24x7 Security"],
    nearbyPlaces: [{ name: "Electronic City", distance: "10 min" }, { name: "Bannerghatta National Park", distance: "15 min" }, { name: "NICE Ring Road", distance: "5 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=600&h=400&fit=crop", caption: "Purva Sparkling Springs Villa" }],
  },

  // ===== PURVA TIVOLI HILLS (PLOTS) =====
  "purva-tivoli-hills": {
    id: "purva-tivoli-hills", name: "Purva Tivoli Hills", builder: "Puravankara", tagline: "European-Themed Plotted Development near Airport",
    location: "Devanahalli, North Bangalore", price: "Starting from \u20b91.60 Cr", priceRange: "\u20b91.60 Cr - \u20b95.00 Cr", pricePerSqft: "\u20b97,000/sq.ft",
    rera: "", possession: "Plots Available", launchDate: "2022", status: "Available",
    landArea: "60 Acres", towers: "N/A (Plots)", floors: "N/A", totalUnits: "400+ Plots", openSpace: "60% Open Space", parking: "Individual",
    configurations: [{ type: "Standard Plot", size: "1200 - 2400 sq.ft", price: "\u20b91.60 Cr onwards" }, { type: "Premium Plot", size: "2400 - 4000 sq.ft", price: "\u20b93.00 Cr onwards" }],
    description: "Purva Tivoli Hills is a premium European-themed plotted development at Devanahalli, just 10 minutes from Bangalore International Airport. Spread across 60 acres with wide roads, landscaped parks, and a grand clubhouse, it's the ideal canvas for your dream home.",
    highlights: ["60-acre European-themed development", "10 min from Bangalore Airport", "Premium residential & commercial plots", "Wide internal roads", "Landscaped parks & green spaces", "Grand clubhouse", "High investment potential", "Devanahalli growth corridor"],
    amenities: ["Grand Clubhouse", "Swimming Pool", "Gymnasium", "Jogging Track", "Landscaped Parks", "Children's Play Area", "Sports Courts", "Community Hall", "24x7 Security", "Gated Community"],
    nearbyPlaces: [{ name: "KIA International Airport", distance: "10 min" }, { name: "KIADB Aerospace SEZ", distance: "5 min" }, { name: "Proposed Metro", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&h=400&fit=crop", caption: "Purva Tivoli Hills" }],
  },

  // ===== SOBHA PROJECTS =====
  "sobha-townpark": {
    id: "sobha-townpark", name: "Sobha Town Park", builder: "Sobha Limited", tagline: "NYC-Themed Luxury Living at Hosur Road",
    location: "Hosur Road, near Electronic City, South Bangalore", price: "Starting from \u20b91.60 Cr", priceRange: "\u20b91.60 Cr - \u20b93.20 Cr", pricePerSqft: "\u20b912,000-14,000/sq.ft",
    rera: "", possession: "December 2026-2027", launchDate: "2023", status: "Under Construction",
    landArea: "33 Acres", towers: "Multiple Towers", floors: "G+25 Floors", totalUnits: "1800+ Units", openSpace: "70% Open Space", parking: "3-Level Basement",
    configurations: [{ type: "2 BHK", size: "1240 sq.ft SBA (835 sq.ft carpet)", price: "\u20b91.60 Cr onwards" }, { type: "3 BHK", size: "1650 sq.ft SBA (1100 sq.ft carpet)", price: "\u20b92.10 Cr onwards" }, { type: "4 BHK", size: "2400 sq.ft SBA (1700 sq.ft carpet)", price: "\u20b93.20 Cr onwards" }, { type: "4.5 BHK", size: "2800 sq.ft SBA", price: "\u20b93.50 Cr onwards" }],
    description: "Sobha Town Park is a magnificent 33-acre NYC-themed residential project on Hosur Road. With 70% open space, 75+ world-class amenities, and proximity to Electronic City, it offers an unmatched urban living experience.",
    highlights: ["33-acre NYC-themed township", "70% open space", "75+ world-class amenities", "20% upfront payment plan", "Near Electronic City IT Hub", "Multiple tower configurations", "Premium clubhouse & recreation", "Excellent Hosur Road connectivity"],
    amenities: ["Olympic Swimming Pool", "Grand Clubhouse", "Gymnasium", "Tennis Court", "Basketball Court", "Badminton Court", "Cricket Net", "Jogging Track", "Children's Play Zone", "Amphitheatre", "Mini Theatre", "Indoor Games", "Party Hall", "Co-working Space", "Yoga Deck", "Senior Citizen Area", "Pet Park", "Skating Rink", "24x7 Security"],
    nearbyPlaces: [{ name: "Electronic City", distance: "10 min" }, { name: "Hosur Road", distance: "Adjacent" }, { name: "NICE Road", distance: "5 min" }, { name: "Metro (Planned)", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop", caption: "Sobha Town Park" }],
  },
  "sobha-neopolis": {
    id: "sobha-neopolis", name: "Sobha Neopolis", builder: "Sobha Limited", tagline: "Premium Living on Panathur Road",
    location: "Panathur Road, Balagere, East Bangalore", price: "Starting from \u20b987 Lakhs", priceRange: "\u20b987 Lakhs - \u20b93.90 Cr", pricePerSqft: "\u20b915,600/sq.ft",
    rera: "", possession: "2027", launchDate: "2023", status: "Under Construction",
    landArea: "25 Acres", towers: "19 Towers", floors: "G+20 Floors", totalUnits: "1875 Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "1 BHK", size: "660 sq.ft", price: "\u20b987 Lakhs onwards" }, { type: "3 BHK", size: "1611-1915 sq.ft", price: "\u20b92.15 Cr onwards" }, { type: "3.5 BHK", size: "1860 sq.ft", price: "\u20b92.60 Cr onwards" }, { type: "4 BHK", size: "2400-2481 sq.ft", price: "\u20b93.48 Cr onwards" }],
    description: "Sobha Neopolis is a premium 25-acre residential community on Panathur Road with 19 towers and 1875 units. Offering 1 to 4 BHK apartments near Whitefield IT hub, it's one of Sobha's largest Bangalore projects with 10-12% yearly appreciation.",
    highlights: ["25 acres, 19 towers, 1875 units", "75% open space", "Near Whitefield & ORR IT corridor", "1 BHK to 4 BHK options", "10-12% yearly appreciation", "Premium Sobha quality construction", "Comprehensive amenity package", "Excellent resale & rental demand"],
    amenities: ["Swimming Pool", "Gymnasium", "Grand Clubhouse", "Tennis Court", "Jogging Track", "Badminton Court", "Children's Play Area", "Amphitheatre", "Indoor Games", "Party Hall", "Co-working Space", "24x7 Security"],
    nearbyPlaces: [{ name: "Whitefield", distance: "5 min" }, { name: "ORR", distance: "5 min" }, { name: "D-Mart", distance: "4.5 km" }, { name: "Schools", distance: "Nearby" }],
    images: [{ url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&fit=crop", caption: "Sobha Neopolis" }],
  },
  "sobha-altair": {
    id: "sobha-altair", name: "Sobha Altair", builder: "Sobha Limited", tagline: "Luxury Residences on Sarjapur Road",
    location: "Sarjapur Road, Hadosiddapura, East Bangalore", price: "Starting from \u20b92.37 Cr", priceRange: "\u20b92.37 Cr - \u20b94.88 Cr", pricePerSqft: "\u20b918,000+/sq.ft",
    rera: "PRM/KA/RERA/1251/446/PR/070126/008388", possession: "May 2031", launchDate: "2026", status: "New Launch",
    landArea: "3.35 Acres", towers: "3 Towers", floors: "B+G+18 Floors", totalUnits: "207-290 Units", openSpace: "70% Open Space", parking: "3-Level Basement",
    configurations: [{ type: "3 BHK", size: "1850-1875 sq.ft", price: "\u20b92.37 Cr onwards" }, { type: "3 BHK + Study", size: "2250 sq.ft", price: "\u20b94.10 Cr onwards" }, { type: "3.5 BHK", size: "2100 sq.ft", price: "\u20b92.69 Cr onwards" }, { type: "4 BHK", size: "2400 sq.ft", price: "\u20b94.45 Cr onwards" }, { type: "4 BHK + Garden", size: "2550 sq.ft", price: "\u20b94.80 Cr onwards" }],
    description: "Sobha Altair on Sarjapur Road is a new luxury launch offering 3, 3.5 & 4 BHK apartments across 3 towers. With premium specifications, 100% power backup, and proximity to major IT corridors, it represents the pinnacle of Sobha quality.",
    highlights: ["Premium Sarjapur Road address", "3 towers, 18 floors each", "100% power backup for lifts & common areas", "50% backup for apartments", "Near ORR, Hosur Road, NICE Road", "Close to IT parks & business centers", "Premium schools & shopping nearby", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Landscaped Gardens", "Jogging Track", "Tennis Court", "Children's Play Area", "Indoor Games", "Party Hall", "Yoga Deck", "24x7 Security"],
    nearbyPlaces: [{ name: "Outer Ring Road", distance: "5 min" }, { name: "Sarjapur Road IT Hub", distance: "Adjacent" }, { name: "RGA Tech Park", distance: "Walking" }],
    images: [{ url: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=400&fit=crop", caption: "Sobha Altair" }],
  },
  "sobha-magnus": {
    id: "sobha-magnus", name: "Sobha Magnus", builder: "Sobha Limited", tagline: "Eco-Luxe Biophilic Design at Bannerghatta",
    location: "Bannerghatta Main Road, South Bangalore", price: "Starting from \u20b92.00 Cr", priceRange: "\u20b92.00 Cr - \u20b93.50 Cr", pricePerSqft: "\u20b913,000/sq.ft",
    rera: "", possession: "2027", launchDate: "2023", status: "Under Construction",
    landArea: "8 Acres", towers: "5 Towers", floors: "G+22 Floors", totalUnits: "578 Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "1856 sq.ft", price: "\u20b92.00 Cr onwards" }, { type: "4 BHK", size: "2578 sq.ft", price: "\u20b93.00 Cr onwards" }, { type: "Row Houses", size: "3000+ sq.ft", price: "\u20b93.50 Cr onwards", subtitle: "2 Exclusive Row Houses" }],
    description: "Sobha Magnus on Bannerghatta Road features eco-luxe biophilic design with 578 apartments and 2 exclusive row houses. The nature-inspired architecture brings greenery into every aspect of living.",
    highlights: ["Biophilic eco-luxe design", "578 apartments + 2 row houses", "75% open space", "Bannerghatta Road premium location", "Nature-inspired architecture", "Near Electronic City", "Premium Sobha construction quality", "Comprehensive amenity package"],
    amenities: ["Swimming Pool", "Gymnasium", "Eco Clubhouse", "Jogging Track", "Tennis Court", "Badminton Court", "Children's Play Area", "Amphitheatre", "Indoor Games", "Yoga Zone", "24x7 Security"],
    nearbyPlaces: [{ name: "Electronic City", distance: "15 min" }, { name: "NICE Road", distance: "5 min" }, { name: "Bannerghatta National Park", distance: "10 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&h=400&fit=crop", caption: "Sobha Magnus" }],
  },
  "sobha-infinia": {
    id: "sobha-infinia", name: "Sobha Infinia", builder: "Sobha Limited", tagline: "Ultra-Luxe Living in Koramangala",
    location: "Koramangala, Central Bangalore", price: "Starting from \u20b92.50 Cr", priceRange: "\u20b92.50 Cr - \u20b94.00 Cr", pricePerSqft: "\u20b925,000+/sq.ft",
    rera: "", possession: "2027", launchDate: "2023", status: "Under Construction",
    landArea: "3 Acres", towers: "2 Towers", floors: "G+28 Floors", totalUnits: "34 Units", openSpace: "65% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "1768 sq.ft", price: "\u20b92.50 Cr onwards" }, { type: "4 BHK", size: "3264 sq.ft", price: "\u20b94.00 Cr onwards" }],
    description: "Sobha Infinia in Koramangala is an ultra-luxe residential project with only 34 exclusive units. This limited-edition project in one of Bangalore's most sought-after addresses offers unmatched privacy and luxury.",
    highlights: ["Only 34 exclusive units", "Koramangala premium address", "Ultra-luxury specifications", "Walking distance to restaurants & shopping", "Near MG Road & Indiranagar", "Limited-edition residences", "Top Sobha craftsmanship", "Investment-grade location"],
    amenities: ["Infinity Pool", "Premium Gymnasium", "Exclusive Clubhouse", "Concierge Service", "Indoor Games", "Yoga Studio", "24x7 Security"],
    nearbyPlaces: [{ name: "Forum Mall", distance: "5 min" }, { name: "MG Road", distance: "10 min" }, { name: "Indiranagar", distance: "8 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=600&h=400&fit=crop", caption: "Sobha Infinia" }],
  },
  "sobha-insignia": {
    id: "sobha-insignia", name: "Sobha Insignia", builder: "Sobha Limited", tagline: "Bespoke Tech-Enabled Residences",
    location: "Bhoganahalli, IT Corridor, East Bangalore", price: "Starting from \u20b92.80 Cr", priceRange: "\u20b92.80 Cr - \u20b95.00 Cr", pricePerSqft: "\u20b916,000/sq.ft",
    rera: "PRM/KA/RERA/1251/309/PR/180524/006894", possession: "2026", launchDate: "2022", status: "Sold Out",
    landArea: "5 Acres", towers: "3 Towers", floors: "G+22 Floors", totalUnits: "350 Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "1819 sq.ft", price: "\u20b92.80 Cr onwards" }, { type: "3.5 BHK", size: "2500 sq.ft", price: "\u20b93.80 Cr onwards" }, { type: "4 BHK", size: "3406 sq.ft", price: "\u20b95.00 Cr onwards" }],
    description: "Sobha Insignia in Bhoganahalli offers bespoke tech-enabled residences in the heart of Bangalore's IT corridor. Now sold out, this project set a benchmark for smart luxury living with premium Sobha craftsmanship.",
    highlights: ["Bespoke tech-enabled homes", "IT corridor prime location", "Smart home automation", "Sold out \u2014 testament to demand", "Premium Sobha specifications", "Near Bellandur & Marathahalli", "Excellent rental yields", "Walking distance to IT parks", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Smart Home Systems", "Tennis Court", "Jogging Track", "Children's Play Area", "Indoor Games", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "ORR IT Parks", distance: "Walking" }, { name: "Bellandur", distance: "5 min" }, { name: "Marathahalli", distance: "8 min" }],
    images: [
      { url: "/images/insignia/img_1_0.jpeg", caption: "Sobha Insignia - Grand Aerial View" },
      { url: "/images/insignia/img_2_0.jpeg", caption: "Sobha Insignia - Tower Perspective" },
      { url: "/images/insignia/img_0_0.jpeg", caption: "Sobha Insignia - Brochure Cover" },
      { url: "/images/insignia/img_10_0.jpeg", caption: "Sobha Insignia - Lifestyle View" },
      { url: "/images/insignia/img_12_0.jpeg", caption: "Sobha Insignia - Amenities" },
      { url: "/images/insignia/img_13_0.jpeg", caption: "Sobha Insignia - Interior Design" },
    ],
  },
  "sobha-ayana": {
    id: "sobha-ayana", name: "Sobha Ayana", builder: "Sobha Limited", tagline: "Premium Living at Dream Acres",
    location: "Panathur, Balagere, East Bangalore", price: "Starting from \u20b91.96 Cr", priceRange: "\u20b91.96 Cr - \u20b92.60 Cr", pricePerSqft: "\u20b912,600-14,500/sq.ft",
    rera: "PRM/KA/RERA/1251/446/PR/030824/006958", possession: "December 2031", launchDate: "2024", status: "Under Construction",
    landArea: "6.28 Acres (part of 81-acre Dream Acres)", towers: "12 Buildings", floors: "G+14 Floors", totalUnits: "683 Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "3 BHK", size: "1553 sq.ft", price: "\u20b91.96 Cr onwards" }, { type: "3 BHK Large", size: "1789 sq.ft", price: "\u20b92.26 Cr onwards" }],
    description: "Sobha Ayana at Dream Acres in Panathur offers premium 3 BHK apartments as part of the larger 81-acre Sobha Dream Acres community. With 100+ amenities across the township and proximity to Whitefield, it's ideal for IT professionals.",
    highlights: ["Part of 81-acre Sobha Dream Acres", "100+ community amenities", "Near Whitefield & Varthur", "6.28 acres, 683 units", "14.64% price appreciation", "Premium Sobha construction", "Excellent IT corridor location", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Squash Court", "Tennis Court", "Jogging Track", "Children's Play Area", "Camping Grounds", "Yoga Lawns", "Indoor Games", "24x7 Security"],
    nearbyPlaces: [{ name: "Whitefield IT Hub", distance: "5 min" }, { name: "Varthur", distance: "3 min" }, { name: "D-Mart", distance: "4.5 km" }],
    images: [{ url: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=600&h=400&fit=crop", caption: "Sobha Ayana" }],
  },
  "sobha-hoskote": {
    id: "sobha-hoskote", name: "Sobha Hoskote", builder: "Sobha Limited", tagline: "Exclusive Duplex & Triplex Row Houses",
    location: "Kannamangala-Hoskote Road, East Bangalore", price: "Starting from \u20b94.75 Cr", priceRange: "\u20b94.75 Cr - \u20b96.69 Cr", pricePerSqft: "\u20b915,800/sq.ft",
    rera: "", possession: "2027", launchDate: "2024", status: "New Launch",
    landArea: "4.08 Acres", towers: "N/A (Row Houses)", floors: "G+2/G+3", totalUnits: "40 Units", openSpace: "75% Open Space", parking: "Private Parking",
    configurations: [{ type: "4 BHK Duplex", size: "3009 sq.ft", price: "\u20b94.75 Cr onwards" }, { type: "4 BHK Triplex", size: "4340 sq.ft", price: "\u20b96.69 Cr onwards" }],
    description: "Sobha's Hoskote project offers exclusive 4 BHK duplex and triplex row houses on 4.08 acres with only 40 ultra-premium units. Located on Kannamangala-Hoskote Road, this gated community provides unmatched privacy and space.",
    highlights: ["Only 40 exclusive units", "4 BHK Duplex & Triplex options", "Ultra-premium row houses", "75% open space", "Private gardens & parking", "Near developing Hoskote corridor", "Future metro connectivity", "Investment-grade location"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Children's Play Area", "Landscaped Gardens", "Sports Courts", "24x7 Security"],
    nearbyPlaces: [{ name: "Hoskote Junction", distance: "5 min" }, { name: "Whitefield", distance: "20 min" }, { name: "Airport Road", distance: "15 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&h=400&fit=crop", caption: "Sobha Hoskote" }],
  },
  "sobha-lifestyle-legacy": {
    id: "sobha-lifestyle-legacy", name: "Sobha Lifestyle Legacy", builder: "Sobha Limited", tagline: "Super Luxury Gated Villas at Devanahalli",
    location: "IVC Road, Devanahalli, North Bangalore", price: "Starting from \u20b95.00 Cr", priceRange: "\u20b95.00 Cr - \u20b910.00 Cr", pricePerSqft: "\u20b98,200/sq.ft",
    rera: "", possession: "Ready to Move", launchDate: "2019", status: "Ready to Move",
    landArea: "25 Acres", towers: "N/A (Villas)", floors: "G+2", totalUnits: "100 Villas", openSpace: "85% Open Space", parking: "Private Multi-Car Parking",
    configurations: [{ type: "3 BHK Villa", size: "6100 sq.ft", price: "\u20b95.00 Cr onwards" }, { type: "4 BHK Villa", size: "7900 sq.ft", price: "\u20b98.00 Cr onwards" }],
    description: "Sobha Lifestyle Legacy at IVC Road, Devanahalli offers super luxury gated villas with private pools. Spread across 25 acres with 85% open space, these grand 3 & 4 BHK villas (6100-7900 sq.ft) offer an unparalleled lifestyle near the international airport.",
    highlights: ["Super luxury gated villas", "6100-7900 sq.ft per villa", "Private swimming pools", "25 acres with 85% open space", "Near international airport", "Ready to move in", "Premium Sobha villa community", "IVC Road growth corridor"],
    amenities: ["Private Swimming Pool (per villa)", "Grand Clubhouse", "Community Pool", "Gymnasium", "Tennis Court", "Basketball Court", "Jogging Track", "Landscaped Gardens", "Children's Play Area", "Party Hall", "Spa", "24x7 Security"],
    nearbyPlaces: [{ name: "KIA International Airport", distance: "10 min" }, { name: "IVC Road Corridor", distance: "Adjacent" }, { name: "Devanahalli Town", distance: "5 min" }],
    images: [{ url: "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=600&h=400&fit=crop", caption: "Sobha Lifestyle Legacy Villa" }],
  },
  "sobha-chartered-birdsong": {
    id: "sobha-chartered-birdsong", name: "Sobha Chartered Birdsong", builder: "Sobha Limited", tagline: "Premium Plots in Yelahanka",
    location: "Rajankunte, Yelahanka, off Doddaballapur Road, North Bangalore", price: "Starting from \u20b984 Lakhs", priceRange: "\u20b984 Lakhs - \u20b92.10 Cr", pricePerSqft: "\u20b97,000/sq.ft",
    rera: "PRM/KA/RERA/1251/472/PR/210325/007605", possession: "December 2028", launchDate: "2025", status: "New Launch",
    landArea: "19-20 Acres", towers: "N/A (Plots)", floors: "N/A", totalUnits: "265 Plots", openSpace: "40% Open Space", parking: "Individual",
    configurations: [{ type: "Standard Plot", size: "1200 sq.ft", price: "\u20b984 Lakhs onwards" }, { type: "Medium Plot", size: "2000 sq.ft", price: "\u20b91.40 Cr onwards" }, { type: "Premium Plot", size: "3000 sq.ft", price: "\u20b92.10 Cr onwards" }],
    description: "Sobha Chartered Birdsong is a premium plotted development in Yelahanka with 265 plots across 19-20 acres. At just \u20b97,000/sq.ft, it offers the freedom to build your dream home in a Sobha-quality gated community near Doddaballapur Road.",
    highlights: ["265 premium plots by Sobha", "1200-3000 sq.ft plot sizes", "\u20b97,000/sq.ft \u2014 excellent value", "RERA Registered", "Gated community with amenities", "Near Yelahanka Railway Station", "Doddaballapur Road connectivity", "Build your dream home"],
    amenities: ["Clubhouse", "Swimming Pool", "Gymnasium", "Landscaped Parks", "Jogging Track", "Children's Play Area", "Sports Courts", "24x7 Security", "Gated Community"],
    nearbyPlaces: [{ name: "Doddaballapur Road", distance: "1.2 km" }, { name: "Yelahanka Railway Station", distance: "2.1 km" }, { name: "Bellary Road", distance: "9.3 km" }],
    images: [{ url: "https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=600&h=400&fit=crop", caption: "Sobha Chartered Birdsong" }],
  },

  // ===== BRIGADE PROJECTS =====
  "brigade-eternia": {
    id: "brigade-eternia", name: "Brigade Eternia", builder: "Brigade Group", tagline: "Timeless Living at Yelahanka",
    location: "Yelahanka Main Road, North Bangalore", price: "Starting from \u20b970 Lakhs", priceRange: "\u20b970 Lakhs - \u20b94.46 Cr", pricePerSqft: "\u20b913,000 - \u20b918,000/sq.ft",
    rera: "PRM/KA/RERA/1251/309/PR/070325/007559", possession: "March 2030", launchDate: "March 2025", status: "New Launch",
    landArea: "12-14 Acres", towers: "12 Towers", floors: "G+25 Floors", totalUnits: "1500+ Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "1 BHK", size: "650-803 sq.ft", price: "\u20b970 L - \u20b91.18 Cr" }, { type: "2 BHK", size: "1100-1252 sq.ft", price: "\u20b91.40 - \u20b91.75 Cr" }, { type: "3 BHK", size: "1450-2250 sq.ft", price: "\u20b91.41 - \u20b92.96 Cr" }, { type: "3.5 BHK", size: "1930-2250 sq.ft", price: "\u20b92.89 - \u20b92.99 Cr" }, { type: "4 BHK", size: "2500-2950 sq.ft", price: "\u20b93.99 - \u20b94.46 Cr" }],
    description: "Brigade Eternia on Yelahanka Main Road is a massive new launch by Brigade Group with 12 towers across 12-14 acres. Offering configurations from 1 BHK to 4 BHK, this project caters to first-time buyers to ultra-luxury seekers in North Bangalore's premier corridor.",
    highlights: ["12 towers across 12-14 acres", "1 BHK to 4 BHK configurations", "75% open space", "Yelahanka premium corridor", "Brigade quality construction", "Near KIA International Airport", "Excellent metro connectivity", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Grand Clubhouse", "Tennis Court", "Jogging Track", "Amphitheatre", "Children's Play Area", "Indoor Games", "Party Hall", "Co-working Space", "Yoga Deck", "Senior Citizen Area", "24x7 Security"],
    nearbyPlaces: [{ name: "Yelahanka Railway", distance: "5 min" }, { name: "KIA Airport", distance: "25 min" }, { name: "Hebbal", distance: "10 min" }, { name: "Metro Station", distance: "Nearby" }],
    images: [
      { url: "/images/doc_wa/img_0_1.jpeg", caption: "Brigade Eternia - Master View" },
      { url: "/images/doc_wa/img_0_0.jpeg", caption: "Brigade Eternia - Aerial Perspective" },
      { url: "/images/doc_wa/img_0_3.jpeg", caption: "Brigade Eternia - Elevation" },
      { url: "/images/doc_wa/img_0_4.jpeg", caption: "Brigade Eternia - Tower Design" },
      { url: "/images/doc_wa/img_1_0.jpeg", caption: "Brigade Eternia - Landscape" },
      { url: "/images/doc_wa/img_2_0.jpeg", caption: "Brigade Eternia - Amenities Overview" },
    ],
  },
  "brigade-ebony": {
    id: "brigade-ebony", name: "Ebony at Brigade Orchards", builder: "Brigade Group", tagline: "Premium Living in 135-Acre Smart Township",
    location: "Devanahalli, near KIA Airport, North Bangalore", price: "Starting from \u20b91.25 Cr", priceRange: "\u20b91.25 Cr - \u20b91.85 Cr", pricePerSqft: "\u20b99,500-11,000/sq.ft",
    rera: "", possession: "February 2026", launchDate: "2023", status: "Under Construction",
    landArea: "3.2 Acres (within 135-acre township)", towers: "4 Towers", floors: "G+8 Floors", totalUnits: "232 Units", openSpace: "80% Open Space", parking: "Covered Parking",
    configurations: [{ type: "3 BHK", size: "1600-2000 sq.ft SBA", price: "\u20b91.25 Cr onwards" }, { type: "4 BHK", size: "2000-2365 sq.ft SBA", price: "\u20b91.55 - \u20b91.85 Cr" }],
    description: "Ebony at Brigade Orchards is a boutique premium residential project within the 135-acre Brigade Orchards smart township in Devanahalli. With just 232 units across 4 towers (G+8), it offers a low-density, nature-rich lifestyle 10 minutes from the international airport.",
    highlights: ["Part of 135-acre Brigade Orchards", "232 boutique premium units", "Low-density G+8 towers", "10 min from KIA Airport", "80+ acres open space in township", "School, hospital, retail within", "Smart home automation", "Pet-friendly community"],
    amenities: ["Swimming Pool", "Gymnasium", "Landscaped Gardens", "Zen Garden", "Pet Park", "Children's Play Area", "Sports Courts", "Community Hall", "Smart Home Features", "24x7 Security"],
    nearbyPlaces: [{ name: "KIA Airport", distance: "10 min" }, { name: "NH 44", distance: "Adjacent" }, { name: "Brigade Orchards Hub", distance: "Walking" }],
    images: [
      { url: "/images/ebony/img_4_0.jpeg", caption: "Ebony - Exterior View" },
      { url: "/images/ebony/img_5_0.jpeg", caption: "Ebony - Garden Area" },
      { url: "/images/ebony/img_6_0.jpeg", caption: "Ebony - Living Spaces" },
      { url: "/images/ebony/img_7_0.jpeg", caption: "Ebony - Landscape Design" },
      { url: "/images/ebony/img_10_0.jpeg", caption: "Ebony - Amenities" },
      { url: "/images/ebony/img_12_0.jpeg", caption: "Ebony - Community Living" },
    ],
  },
  "brigade-laurel-maple": {
    id: "brigade-laurel-maple", name: "Brigade Laurel & Maple", builder: "Brigade Group", tagline: "United We Thrive \u2014 Senior & Multigenerational Living",
    location: "Devanahalli, Brigade Orchards, North Bangalore", price: "Starting from \u20b91.50 Cr", priceRange: "\u20b91.50 Cr - \u20b93.00 Cr", pricePerSqft: "\u20b910,000-12,000/sq.ft",
    rera: "", possession: "2027-2028", launchDate: "2025", status: "New Launch",
    landArea: "Part of 135-acre Brigade Orchards", towers: "Multiple Towers", floors: "G+10 Floors", totalUnits: "300+ Units", openSpace: "80% Open Space", parking: "Covered Parking",
    configurations: [{ type: "Laurel \u2014 Senior Living", size: "1000-1500 sq.ft", price: "\u20b91.50 Cr onwards", subtitle: "Independent Living for Seniors" }, { type: "Maple \u2014 Multigenerational", size: "1500-2500 sq.ft", price: "\u20b92.00 Cr onwards", subtitle: "Multigenerational Living Community" }],
    description: "Brigade Laurel & Maple is a unique multigenerational living concept within Brigade Orchards. 'Laurel' offers independent senior living with care services, while 'Maple' provides multigenerational homes where families can live together yet independently. A first-of-its-kind in Bangalore.",
    highlights: ["First multigenerational community in Bangalore", "Laurel: Senior independent living", "Maple: Multigenerational family homes", "Part of 135-acre Brigade Orchards", "Specialized care & wellness services", "Community-driven lifestyle", "Near international airport", "Nature-rich environment"],
    amenities: ["Wellness Center", "Medical Room", "Swimming Pool", "Gymnasium", "Yoga Hall", "Library & Reading Room", "Community Kitchen", "Dining Hall", "Landscaped Walking Paths", "Hobby Rooms", "Meditation Garden", "24x7 Security & Medical Support"],
    nearbyPlaces: [{ name: "KIA Airport", distance: "10 min" }, { name: "Brigade Orchards Hospital", distance: "Walking" }, { name: "NH 44", distance: "Adjacent" }],
    images: [
      { url: "/images/lm/img_1_0.jpeg", caption: "Laurel & Maple - Community View" },
      { url: "/images/lm/img_0_0.png", caption: "Laurel & Maple - Concept Design" },
      { url: "/images/lm/img_10_2.jpeg", caption: "Laurel & Maple - Living Spaces" },
      { url: "/images/lm/img_15_0.jpeg", caption: "Laurel & Maple - Wellness Area" },
      { url: "/images/lm/img_11_0.png", caption: "Laurel & Maple - Landscape Plan" },
    ],
  },
  "brigade-arcade-orchards": {
    id: "brigade-arcade-orchards", name: "Brigade Arcade at Orchards", builder: "Brigade Group", tagline: "Premium Retail & Office Spaces at Brigade Orchards",
    location: "Devanahalli, Brigade Orchards Township, North Bangalore", price: "Starting from \u20b960 Lakhs", priceRange: "\u20b960 Lakhs - \u20b92.00 Cr", pricePerSqft: "\u20b99,000/sq.ft",
    rera: "PRM/KA/RERA/1250/303/PR/180627/001942", possession: "Ready / Nearing Completion", launchDate: "2024", status: "Nearing Completion",
    landArea: "Part of 135-acre Township", towers: "Commercial Block", floors: "G+4 Floors", totalUnits: "100+ Units", openSpace: "40% Open Space", parking: "Ample Parking",
    configurations: [{ type: "Retail Shops", size: "300-1500 sq.ft", price: "\u20b960 Lakhs onwards" }, { type: "Office Spaces", size: "500-2000 sq.ft", price: "\u20b990 Lakhs onwards" }, { type: "Anchor Stores", size: "1500-5000 sq.ft", price: "On Request" }],
    description: "Brigade Arcade at Orchards is a premium commercial destination offering retail shops, office spaces, and anchor store opportunities within the thriving 135-acre Brigade Orchards township. With a captive customer base of 10,000+ families, this is an excellent commercial investment.",
    highlights: ["Within 135-acre Brigade Orchards", "10,000+ captive families", "Retail & office opportunities", "Premium high-street format", "Near international airport", "Excellent ROI potential", "Travel agents, cafes, retail", "RERA Registered"],
    amenities: ["Ample Parking", "High-Street Retail Format", "Modern Architecture", "Power Backup", "Water Supply", "Security", "Signage Opportunities"],
    nearbyPlaces: [{ name: "Brigade Orchards Residences", distance: "Walking" }, { name: "KIA Airport", distance: "10 min" }, { name: "NH 44", distance: "Adjacent" }],
    images: [
      { url: "/images/brigade/img_0_1.jpeg", caption: "Brigade Arcade - Master Plan" },
      { url: "/images/brigade/img_1_1.jpeg", caption: "Brigade Arcade - Street View" },
      { url: "/images/brigade/img_2_1.jpeg", caption: "Brigade Arcade - Retail Spaces" },
      { url: "/images/brigade/img_3_0.jpeg", caption: "Brigade Arcade - Township View" },
    ],
  },
  "brigade-valencia-brillio": {
    id: "brigade-valencia-brillio", name: "Brillio at Brigade Valencia", builder: "Brigade Group", tagline: "The Valencian Upgrade at Electronic City",
    location: "Bommasandra, Electronic City, South Bangalore", price: "Starting from \u20b957.55 Lakhs", priceRange: "\u20b957.55 L - \u20b92.38 Cr", pricePerSqft: "\u20b914,180/sq.ft",
    rera: "PRM/KA/RERA/1251/308/PR/040924/006986", possession: "September 2029", launchDate: "2024", status: "Under Construction",
    landArea: "15.26 Acres", towers: "Multiple Towers", floors: "G+20 Floors", totalUnits: "779 Units", openSpace: "75% Open Space", parking: "Basement Parking",
    configurations: [{ type: "1 BHK", size: "406 sq.ft", price: "\u20b957.55 Lakhs" }, { type: "2 BHK", size: "757-762 sq.ft", price: "\u20b91.07 - \u20b91.08 Cr" }, { type: "3 BHK", size: "978-1,128 sq.ft", price: "\u20b91.39 - \u20b91.60 Cr" }, { type: "4 BHK", size: "1,638-1,679 sq.ft", price: "\u20b92.32 - \u20b92.38 Cr" }],
    description: "Brillio at Brigade Valencia is a premium upgrade in the 115-acre Brigade Valencia township at Bommasandra, Electronic City. With 779 units across 15.26 acres, it offers 1-4 BHK apartments with world-class amenities and excellent IT corridor connectivity.",
    highlights: ["Part of 115-acre Brigade Valencia township", "15.26 acres, 779 units", "Near Electronic City IT Hub", "1 BHK to 4 BHK configurations", "Starting from just \u20b957.55 Lakhs", "75% open space", "Premium Brigade quality", "RERA Registered"],
    amenities: ["Swimming Pool", "Gymnasium", "Grand Clubhouse", "Tennis Court", "Jogging Track", "Children's Play Area", "Amphitheatre", "Indoor Games", "Party Hall", "Co-working Space", "24x7 Security"],
    nearbyPlaces: [{ name: "Electronic City", distance: "Adjacent" }, { name: "Bommasandra Metro", distance: "5 min" }, { name: "Hosur Road", distance: "5 min" }],
    images: [
      { url: "/images/valencia/img_0_15.jpeg", caption: "Brillio - Grand Aerial View" },
      { url: "/images/valencia/img_0_2.jpeg", caption: "Brillio - Tower Design" },
      { url: "/images/valencia/img_0_11.jpeg", caption: "Brillio - Landscape View" },
      { url: "/images/valencia/img_0_12.jpeg", caption: "Brillio - Amenities Overview" },
      { url: "/images/valencia/img_0_7.jpeg", caption: "Brillio - Clubhouse" },
      { url: "/images/valencia/img_10_2.jpeg", caption: "Brillio - Interior Design" },
      { url: "/images/valencia/img_10_3.jpeg", caption: "Brillio - Living Spaces" },
    ],
  },
  "brigade-citrine": {
    id: "brigade-citrine", name: "Brigade Citrine", builder: "Brigade Group", tagline: "India's First Net Zero Community",
    location: "Budigere Cross, Old Madras Road, East Bangalore", price: "Starting from \u20b968.9 Lakhs", priceRange: "\u20b968.9 L - \u20b92.84 Cr", pricePerSqft: "\u20b910,000 - \u20b911,210/sq.ft",
    rera: "PRM/KA/RERA/1250/304/PR/131224/007287", possession: "June 2029", launchDate: "2024", status: "Under Construction",
    landArea: "4.3 Acres", towers: "3 Towers", floors: "G+18 Floors", totalUnits: "420 Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "1 BHK", size: "689 sq.ft", price: "\u20b968.9 - \u20b985 Lakhs" }, { type: "2 BHK", size: "1,250 sq.ft", price: "\u20b91.25 - \u20b91.39 Cr" }, { type: "3 BHK", size: "1,548-1,766 sq.ft", price: "\u20b91.55 - \u20b92.06 Cr" }, { type: "4 BHK", size: "2,528-2,533 sq.ft", price: "\u20b92.83 - \u20b92.84 Cr" }],
    description: "Brigade Citrine is India's first Net Zero residential community with a Net Zero Vision-2045. Located at Budigere Cross on Old Madras Road, this 4.3-acre development offers carbon-neutral, sustainable living with apartments that face the world, not each other.",
    highlights: ["India's First Net Zero Community", "Net Zero Vision-2045", "Carbon-neutral living", "Apartments face outward, not each other", "4.3 acres with green design", "Energy & water efficient", "Sustainable construction materials", "RERA Registered"],
    amenities: ["Swimming Pool", "Green Gymnasium", "Eco Clubhouse", "Rooftop Solar Panels", "Rainwater Harvesting", "EV Charging", "Jogging Track", "Children's Play Area", "Community Garden", "Waste Management", "24x7 Security"],
    nearbyPlaces: [{ name: "Old Madras Road", distance: "Adjacent" }, { name: "KR Puram", distance: "10 min" }, { name: "Whitefield", distance: "15 min" }],
    images: [
      { url: "/images/citrine/img_15_0.jpeg", caption: "Brigade Citrine - Exterior View" },
      { url: "/images/citrine/img_13_0.jpeg", caption: "Brigade Citrine - Green Design" },
      { url: "/images/citrine/img_14_0.jpeg", caption: "Brigade Citrine - Net Zero Living" },
      { url: "/images/citrine/img_16_0.jpeg", caption: "Brigade Citrine - Landscape" },
      { url: "/images/citrine/img_17_0.jpeg", caption: "Brigade Citrine - Amenities" },
      { url: "/images/citrine/img_12_0.jpeg", caption: "Brigade Citrine - Interior" },
    ],
  },
  "brigade-lakecrest": {
    id: "brigade-lakecrest", name: "Brigade Lakecrest", builder: "Brigade Group", tagline: "A Life of Pride \u2014 Lakeside Living",
    location: "Old Madras Road, KR Puram, East Bangalore", price: "Starting from \u20b956.59 Lakhs", priceRange: "\u20b956.59 L - \u20b92.39 Cr", pricePerSqft: "\u20b911,680/sq.ft",
    rera: "", possession: "March 2030", launchDate: "2025", status: "New Launch",
    landArea: "5.37 Acres", towers: "5 Towers", floors: "G+25 Floors", totalUnits: "604 Units", openSpace: "70% Open Space", parking: "Basement Parking",
    configurations: [{ type: "1 RK", size: "482-493 sq.ft", price: "\u20b956.59 - \u20b957.88 Lakhs" }, { type: "1 BHK", size: "775-814 sq.ft", price: "\u20b991 - \u20b995.58 Lakhs" }, { type: "2 BHK", size: "1,315-1,512 sq.ft", price: "\u20b91.44 - \u20b91.68 Cr" }, { type: "2.5 BHK", size: "1,410-1,568 sq.ft", price: "\u20b91.55 - \u20b91.83 Cr" }, { type: "3 BHK", size: "1,784-2,010 sq.ft", price: "\u20b91.95 - \u20b92.39 Cr" }],
    description: "Brigade Lakecrest on Old Madras Road offers lakeside living by the serene Bhattarahalli Lake. With 604 units across 5.37 acres, this project brings comfort blended with nature \u2014 a privilege reserved for the discerning few.",
    highlights: ["Lakeside living by Bhattarahalli Lake", "5.37 acres, 604 units", "1 RK to 3 BHK options", "Premium Old Madras Road location", "Near KR Puram & Whitefield", "Starting from \u20b956.59 Lakhs", "Serene lake views", "Brigade quality construction"],
    amenities: ["Swimming Pool", "Gymnasium", "Lakeside Clubhouse", "Jogging Track", "Lake-view Deck", "Children's Play Area", "Indoor Games", "Party Hall", "Yoga Area", "24x7 Security"],
    nearbyPlaces: [{ name: "Bhattarahalli Lake", distance: "Adjacent" }, { name: "KR Puram", distance: "5 min" }, { name: "Whitefield", distance: "15 min" }, { name: "Old Madras Road", distance: "Adjacent" }],
    images: [
      { url: "/images/lakecrest/page_2.jpeg", caption: "Lakecrest - Lakeside Living" },
      { url: "/images/lakecrest/page_5.jpeg", caption: "Lakecrest - Tower & Lake View" },
      { url: "/images/lakecrest/page_8.jpeg", caption: "Lakecrest - Amenities" },
      { url: "/images/lakecrest/page_10.jpeg", caption: "Lakecrest - Lifestyle" },
      { url: "/images/lakecrest/page_12.jpeg", caption: "Lakecrest - Floor Plans" },
      { url: "/images/lakecrest/img_12_0.jpeg", caption: "Lakecrest - Lake Panorama" },
    ],
  },
  "brigade-belvedere": {
    id: "brigade-belvedere", name: "Brigade Belvedere", builder: "Brigade Group", tagline: "In Love with Beautiful Vistas \u2014 43 Floors of Grandeur",
    location: "Budigere Cross, Aavalahalli, East Bangalore", price: "Starting from \u20b995 Lakhs", priceRange: "\u20b995 L - \u20b92.72 Cr", pricePerSqft: "\u20b912,000-14,000/sq.ft",
    rera: "", possession: "December 2030", launchDate: "2025", status: "New Launch",
    landArea: "10.75 Acres", towers: "5 Towers", floors: "3B+G+43 Floors", totalUnits: "775 Units", openSpace: "80% Open Space", parking: "3-Level Basement",
    configurations: [{ type: "1 BHK", size: "444 sq.ft carpet", price: "\u20b995 Lakhs onwards" }, { type: "2 BHK", size: "650-700 sq.ft carpet", price: "\u20b91.40 Cr onwards" }, { type: "3 BHK", size: "850-950 sq.ft carpet", price: "\u20b91.90 Cr onwards" }, { type: "3.5 BHK", size: "1,111 sq.ft carpet", price: "\u20b92.50 - \u20b92.72 Cr" }],
    description: "Brigade Belvedere at Budigere Cross is a landmark 43-storey development offering breathtaking skyline views. With 5 towers across 10.75 acres and 80% open space, this project brings panoramic living with smart home automation to East Bangalore.",
    highlights: ["43-storey landmark towers", "10.75 acres with 80% open space", "Breathtaking skyline & panoramic views", "Smart home automation", "775 premium units", "Near Whitefield & OMR", "3-level basement parking", "30% price appreciation potential"],
    amenities: ["Infinity Swimming Pool", "Sky Lounge", "Gymnasium", "Grand Clubhouse", "Tennis Court", "Jogging Track", "Amphitheatre", "Children's Play Area", "Indoor Games", "Co-working Space", "Party Hall", "24x7 Security"],
    nearbyPlaces: [{ name: "Budigere Cross", distance: "Adjacent" }, { name: "Whitefield", distance: "15 min" }, { name: "KR Puram", distance: "10 min" }, { name: "Airport", distance: "30 min" }],
    images: [
      { url: "/images/belvedere/img_2_0.jpeg", caption: "Belvedere - 43-Floor Tower View" },
      { url: "/images/belvedere/img_11_0.jpeg", caption: "Belvedere - Aerial Perspective" },
      { url: "/images/belvedere/img_1_0.jpeg", caption: "Belvedere - Grand Design" },
      { url: "/images/belvedere/img_10_1.jpeg", caption: "Belvedere - Amenities" },
      { url: "/images/belvedere/img_0_0.jpeg", caption: "Belvedere - Panoramic Views" },
    ],
  },
  "sobha-avalon": {
    id: "sobha-avalon", name: "Sobha Avalon", builder: "Sobha Limited", tagline: "Premium Living at GIFT City, Gujarat",
    location: "GIFT City, Gandhinagar, Gujarat", price: "Starting from \u20b91.35 Cr", priceRange: "\u20b91.35 Cr - \u20b92.50 Cr", pricePerSqft: "\u20b912,840/sq.ft",
    rera: "", possession: "March 2027", launchDate: "2024", status: "Under Construction",
    landArea: "1.34 Acres", towers: "1 Tower", floors: "2B+G+3P+31 Floors", totalUnits: "268 Units", openSpace: "50% Open Space", parking: "Podium + Basement",
    configurations: [{ type: "1 BHK", size: "405 sq.ft carpet", price: "\u20b91.35 Cr onwards" }, { type: "1.5 BHK", size: "600 sq.ft carpet", price: "\u20b91.55 Cr onwards" }, { type: "2 BHK", size: "800 sq.ft carpet", price: "\u20b91.85 Cr onwards" }, { type: "3 BHK", size: "1,200 sq.ft carpet", price: "\u20b92.30 Cr onwards" }],
    description: "Sobha Avalon is a premium residential tower at GIFT City, Gandhinagar \u2014 India's first operational smart city and International Financial Services Centre. With 31 floors and 268 units, it offers a world-class address for professionals in the GIFT City corridor.",
    highlights: ["GIFT City \u2014 India's first smart city", "International Financial Services Centre", "31-floor landmark tower", "268 exclusive units", "Near Jamnabai Narsee School", "Smart city infrastructure", "Excellent capital appreciation", "Sobha premium construction"],
    amenities: ["Swimming Pool", "Gymnasium", "Clubhouse", "Jogging Track", "Children's Play Area", "Indoor Games", "Party Hall", "CCTV Security", "24x7 Security"],
    nearbyPlaces: [{ name: "GIFT Bridge", distance: "Walking" }, { name: "Jamnabai Narsee School", distance: "300m" }, { name: "Gandhinagar Station", distance: "10 min" }],
    images: [
      { url: "/images/avalon/img_0_0.jpeg", caption: "Sobha Avalon - Tower View" },
      { url: "/images/avalon/img_1_0.jpeg", caption: "Sobha Avalon - Exterior Design" },
      { url: "/images/avalon/img_1_1.jpeg", caption: "Sobha Avalon - Night View" },
      { url: "/images/avalon/img_3_0.jpeg", caption: "Sobha Avalon - Amenities" },
      { url: "/images/avalon/img_10_0.jpeg", caption: "Sobha Avalon - Living Space" },
      { url: "/images/avalon/img_11_0.jpeg", caption: "Sobha Avalon - Interior" },
    ],
  },
};

export const SERVICES = [
  { id: 1, title: "Real Estate Consultation", description: "Our team of real estate experts provides personalized one-on-one consultations to simplify the process of buying, selling, or leasing property. We guide you every step of the way.", icon: "building2" },
  { id: 2, title: "Housing Loan Services", description: "Get the best housing loan deals with minimal down payments, flexible financing options, easy documentation, and comprehensive tax benefits guidance.", icon: "banknote" },
  { id: 3, title: "Interior Design Services", description: "Transform your property with our professional, affordable, and trendy interior design solutions that perfectly match your style and preferences.", icon: "palette" },
  { id: 4, title: "Legal Consultation", description: "Our legal specialists manage all paperwork and formalities for property deals, providing end-to-end support to ensure smooth and secure transactions.", icon: "scale" },
];

export const TESTIMONIALS = [
  { 
    id: 1, 
    name: "Manoj", 
    role: "Investor - Sobha Townpark", 
    text: "I wasn't just sold a property. I was shown a possibility I hadn't even considered. The clarity about how a slightly higher investment could lead to better returns, combined with visiting the project with my family, shifted my perspective completely. It felt like more than just an investment — it felt like a future for my children.", 
    rating: 5, 
    avatar: "MJ" 
  },
  { 
    id: 2, 
    name: "Praba", 
    role: "Business Owner - Sobha Townpark Phase 1", 
    text: "I'm cautious about investments and usually don't entertain property calls. But this was different. The visit changed everything — the quality, the professionalism, and learning about Sobha's backward integration gave me confidence. Within a year, my investment almost doubled. Sobha didn't just give me an apartment. They gave me confidence, clarity, and a decision I'm genuinely proud of.", 
    rating: 5, 
    avatar: "PB" 
  },
  { 
    id: 3, 
    name: "Raghav", 
    role: "Restaurant Owner - Sobha Townpark", 
    text: "Real estate was new to me. I had many doubts about the location, resale potential, and long-term value. But after the visit, my questions were answered patiently. They showed me where the market was heading. After a few years, it's one of the best decisions I've made. The property's value grew significantly, far beyond what I initially expected. Sometimes, all it takes is one right decision to change your financial path.", 
    rating: 5, 
    avatar: "RV" 
  },
];

export const ABOUT_FEATURES = [
  { title: "Curated Selection", description: "Hand-picked properties that meet our rigorous quality and value standards, ensuring you only see the best." },
  { title: "Expert Guidance", description: "Our seasoned professionals provide market insights, financial planning, and negotiation support for maximum value." },
  { title: "White Glove Service", description: "Dedicated, personalized attention from property search to final handover, ensuring a seamless experience." },
];
